import { Component, OnDestroy, OnInit, Input, ViewChild, ChangeDetectorRef, TemplateRef } from '@angular/core';
import { DropdownTableColumn, IDropdownTableColumn, ITableColumn, NewTableEditorUserViewOptions, TableColumn } from 'new-table-editor';
import { forkJoin, Observable, Subject, Subscription } from 'rxjs';
import { tap, takeUntil, share, map, single } from 'rxjs/operators';
import { IUserTokenModel, StarbaseLoginService } from 'starbase-login';
import { StarbaseModalButton, StarbaseModalDialogService, StarbaseModalOptions, StarbaseModalTypes } from 'starbase-modal-dialog';
import { AppGlobalsService } from '../services/app-globals.service';
import { IEditCheck } from '../services/auth-guard.service';
import { SiteDataService } from '../services/site-data.service';
import { STContactDataService } from '../services/st-contact-data.service';
import { StarbaseComponentMessageService } from '../services/starbase-component-message.service';
import { LU_MaterialService, LU_MaterialServiceDetail, ScaleTicketHeader ,LU_STContactType, LU_Grid, LU_JobCategory, LU_JobCode, LU_MaterialSubCategory, LU_STUnitOfMeasure, LU_VehicleType, LU_Tax, LU_InvoiceBatch, Invoice, STContact, Job, CustomerSelectComponent, StarbaseServicesProviderBase, ScaleTicketStatusEnum, LocationModel, Payment } from 'scaletech-core';
import { JobDataServiceBase } from 'scaletech-jobs';
import { ISelectable, FilterParams } from 'starbase-launcher';
import { StarbaseNotificationObject, StarbaseNotificationSentiment } from 'starbase-notification';
import { LU_JobCodeService } from '../services/lookups/lu-job-code.service';
import { LU_GridService } from '../services/lookups/lu-grid.service';
import { LU_ContactTypeService } from '../services/lookups/lu-contact-type.service';
import { LU_JobCategoryService } from '../services/lookups/lu-job-category.service';
import { LU_MaterialServiceService } from '../services/lookups/lu-material-service.service';
import { LU_TaxService } from '../services/lookups/lu-tax.service';
import { InvoiceDataService } from '../services/invoice-data.service';
import { LU_UnitOfMeasureService } from '../services/lookups/lu-unit-of-measure.service';
import { LU_VehicleTypeService } from '../services/lookups/lu-vehicle-type.service';
import { VehicleDataService } from '../services/vehicle-data.service';
import { LU_MaterialSubCategoryService } from '../services/lookups/lu-material-sub-category.service';
import { LU_InvoiceBatchService } from '../services/lookups/lu-invoice-batch.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { DatePipe } from '@angular/common';
import { ScaleTicketHeaderServiceBase } from 'scaletech-tickets';
import { JwtHelperService } from '@auth0/angular-jwt';
import { PaymentService } from 'scaletech-payment';

class ReportSection {
  title: string;
  divId: string;
  default: boolean = false;
  monthlyReportFunction: Function;
  yearlyReportFunction: Function;
  reportType: string;
  preBuiltButtons: ReportButton[];
  customReportButtons: ReportButton[];
}

class ReportButton {
  text: string;
  icon: string;
  class: string;
  clickEvent: Function;
  tooltip: string;
  active: boolean;

  constructor(btnText = '', btnClass = 'btn-outline-secondary', btnClickEvent = undefined, active = false) {
    this.text = btnText;
    this.class = btnClass;
    this.clickEvent = btnClickEvent;
    this.active = active;
  }
}

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css'],
  standalone: false,
})
export class ReportsComponent implements OnInit, OnDestroy, IEditCheck {
  @ViewChild('customerSelect') customerSelect: CustomerSelectComponent;
  @Input() mainColor: string;
  @Input() darkMode = false;
  @Input() glassMode = false;
  @Input() tooltipDelay = 1;
  @Input() scaleTicketMode = false;
  @Input() invoiceMode = false;
  @Input() showAll: boolean = false;
  @Input() job: Job = null;
  @Input() ticket: ScaleTicketHeader;
  @Input() invoice: Invoice;

    @ViewChild('locationSelectModal') locationSelectModal: TemplateRef<any>;
    @ViewChild('emptyButtonOverrideTemplate') emptyButtonOverrideTemplate: TemplateRef<any>;

  hardSelectLock = false;
  jobCodes: LU_JobCode[];
  jobCategories: LU_JobCategory[];
  isAdmin = false;
  createQuantityReportWizOpen = false;
  createTonnageReportWizOpen = false;
  createInvoiceReportWizOpen = false;
  createTransactionReportWizOpen = false;
  datePickerModalForInvoiceOpen = false;
  customerStatementModalOpen = false;
  invoiceAgingDetailModalOpen = false;
  dateEntered = false;
  asOf: Date = null;

  reportStyle = '';
  reportTitle = 'Report';
  closeInvoiceSelectorBool = false;

  private currentUser: IUserTokenModel;
  public dropdownTypeDebounceTime;
  public isProcessing = false;
  public selectedInvoices: Invoice[] = [];
  public selectedInvoice: Invoice;

  isDownloading = false;
  isSeasonal = false;
  singleInvoiceReportMode = false;

  statuses: any[] = [];
  materials: any[] = [];
  allMaterials: LU_MaterialService[] = [];
  jobs: Job[] = [];
  allJobs: Job[] = [];
  customer: STContact;
  customers: STContact[] = [];
  allCustomers: STContact[] = [];
  jobsShown: boolean = false;

  private now = new Date();
  private dateCustomClasses = [
    { date: this.now, classes: ['bg-info'] }
  ];
  bsConfig: Partial<BsDatepickerConfig> = {
    isAnimated: true,
    adaptivePosition: true,
    containerClass: 'theme-green',
    showPreviousMonth: true,
    showWeekNumbers: false,
    ranges: [
      {
        value: [new Date(new Date().setHours(0, 0, 0, 0)), new Date()],
        label: 'Today'
      },
      {
        // eslint-disable-next-line max-len
        value: [new Date(new Date(new Date().setDate(new Date().getDate() - 1)).setHours(0, 0, 0, 0)), new Date(new Date(new Date().setDate(new Date().getDate() - 1)).setHours(0, 0, 0, 0))],
        label: 'Yesterday'
      },
      {
        value: [new Date(new Date(new Date().setDate(new Date().getDate() - 7)).setHours(0, 0, 0, 0)), new Date()],
        label: 'Previous 7 Days'
      },
      {
        value: [new Date(new Date(new Date().setMonth(new Date().getMonth() - 6, 1)).setHours(0, 0, 0, 0)), new Date()],
        label: 'Previous 6 Months'
      },
      {
        value: [new Date(new Date(new Date().setMonth(new Date().getMonth(), 1)).setHours(0, 0, 0, 0)), new Date()],
        label: 'Month To Date'
      },
      {
        value: [new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0), new Date()],
        label: 'Year To Date'
      }
    ],
    dateCustomClasses: this.dateCustomClasses
  };

  activeTables = [];
  filterJobCategoryUID = 0;
  filterJobCodeUID = 0;
  filterCustomerUID = 0;
  filterJobUID = 0;
  filterSiteUID = 0;
  filterWeighmaster = '';
  filterStatus = 0;
  filterInvoiceUID = 0;
  filterDateFrom: Date = null;
  filterDateTo: Date = null;
  filterCustomer = '';
  filterMaterial = '';

  collapseTonnage = false;
  collapseTonFinance = false;
  collapseFavorites = false;
  collapseInvoice = false;
  favoriteReports: string[] = [];
  hasFavorites = false;

  months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];

  currentMonth: number = new Date().getMonth();
  startYear: number = 2023;

  reportableMonths: number[] = [
    this.currentMonth,
    this.currentMonth - 1 + (this.currentMonth - 1 < 0 ? 12 : 0),
    this.currentMonth - 2 + (this.currentMonth - 2 < 0 ? 12 : 0),
    this.currentMonth - 3 + (this.currentMonth - 3 < 0 ? 12 : 0),
    this.currentMonth - 4 + (this.currentMonth - 4 < 0 ? 12 : 0),
    this.currentMonth - 5 + (this.currentMonth - 5 < 0 ? 12 : 0),
    this.currentMonth - 6 + (this.currentMonth - 6 < 0 ? 12 : 0)
  ];

  reportableYears = [
    new Date().getFullYear(),
    new Date().getFullYear() - 1,
    new Date().getFullYear() - 2,
    new Date().getFullYear() - 3,
    new Date().getFullYear() - 4
  ];

  summaryDateFrom: Date = null;
  summaryDateTo: Date = null;
  summaryReportMonthButtons: ReportButton[] = [
    new ReportButton(this.months[this.reportableMonths[0]], 'btn-outline-primary', () => this.quickTonnageReportByMonth(this.reportableMonths[0], 'MTSummary'), true),
    new ReportButton(this.months[this.reportableMonths[1]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[1], 'MTSummary'), true),
    new ReportButton(this.months[this.reportableMonths[2]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[2], 'MTSummary'), true),
    new ReportButton(this.months[this.reportableMonths[3]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[3], 'MTSummary'), true),
    new ReportButton(this.months[this.reportableMonths[4]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[4], 'MTSummary'), true),
    new ReportButton(this.months[this.reportableMonths[5]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[5], 'MTSummary'), true),
    new ReportButton(this.months[this.reportableMonths[6]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[6], 'MTSummary'), true)
  ];
  summaryReportYearButtons: ReportButton[] = [
    new ReportButton(this.reportableYears[0].toString(), 'btn-outline-primary', () => this.quickTonnageReportByYear(this.reportableYears[0], 'MTSummary'), true),
    new ReportButton(this.reportableYears[1].toString(), 'btn-outline-secondary', () => this.quickTonnageReportByYear(this.reportableYears[1], 'MTSummary'), true),
    new ReportButton(this.reportableYears[2].toString(), 'btn-outline-secondary', () => this.quickTonnageReportByYear(this.reportableYears[2], 'MTSummary'), true),
    new ReportButton(this.reportableYears[3].toString(), 'btn-outline-secondary', () => this.quickTonnageReportByYear(this.reportableYears[3], 'MTSummary'), true),
    new ReportButton(this.reportableYears[4].toString(), 'btn-outline-secondary', () => this.quickTonnageReportByYear(this.reportableYears[4], 'MTSummary'), true)
  ];

  MatQtySummaryDateFrom: Date = null;
  MatQtySummaryDateTo: Date = null;
  MatQtySummaryReportMonthButtons: ReportButton[] = [
    new ReportButton(this.months[this.reportableMonths[0]], 'btn-outline-primary', () => this.quickMatQtySummaryReportByMonth(this.reportableMonths[0], 'MatQtySummaryReport'), true),
    new ReportButton(this.months[this.reportableMonths[1]], 'btn-outline-secondary', () => this.quickMatQtySummaryReportByMonth(this.reportableMonths[1], 'MatQtySummaryReport'), true),
    new ReportButton(this.months[this.reportableMonths[2]], 'btn-outline-secondary', () => this.quickMatQtySummaryReportByMonth(this.reportableMonths[2], 'MatQtySummaryReport'), true),
    new ReportButton(this.months[this.reportableMonths[3]], 'btn-outline-secondary', () => this.quickMatQtySummaryReportByMonth(this.reportableMonths[3], 'MatQtySummaryReport'), true),
    new ReportButton(this.months[this.reportableMonths[4]], 'btn-outline-secondary', () => this.quickMatQtySummaryReportByMonth(this.reportableMonths[4], 'MatQtySummaryReport'), true),
    new ReportButton(this.months[this.reportableMonths[5]], 'btn-outline-secondary', () => this.quickMatQtySummaryReportByMonth(this.reportableMonths[5], 'MatQtySummaryReport'), true),
    new ReportButton(this.months[this.reportableMonths[6]], 'btn-outline-secondary', () => this.quickMatQtySummaryReportByMonth(this.reportableMonths[6], 'MatQtySummaryReport'), true)
  ];
  MatQtySummaryReportYearButtons: ReportButton[] = [
    new ReportButton(this.reportableYears[0].toString(), 'btn-outline-primary', () => this.quickMatQtySummaryReportByYear(this.reportableYears[0], 'MatQtySummaryReport'), true),
    new ReportButton(this.reportableYears[1].toString(), 'btn-outline-secondary', () => this.quickMatQtySummaryReportByYear(this.reportableYears[1], 'MatQtySummaryReport'), true),
    new ReportButton(this.reportableYears[2].toString(), 'btn-outline-secondary', () => this.quickMatQtySummaryReportByYear(this.reportableYears[2], 'MatQtySummaryReport'), true),
    new ReportButton(this.reportableYears[3].toString(), 'btn-outline-secondary', () => this.quickMatQtySummaryReportByYear(this.reportableYears[3], 'MatQtySummaryReport'), true),
    new ReportButton(this.reportableYears[4].toString(), 'btn-outline-secondary', () => this.quickMatQtySummaryReportByYear(this.reportableYears[4], 'MatQtySummaryReport'), true)
  ];

  comprehensiveDateFrom: Date = null;
  comprehensiveDateTo: Date = null;
  comprehensiveReportMonthButtons: ReportButton[] = [
    new ReportButton(this.months[this.reportableMonths[0]], 'btn-outline-primary', () => this.quickTonnageReportByMonth(this.reportableMonths[0], 'CMSummary'), true),
    new ReportButton(this.months[this.reportableMonths[1]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[1], 'CMSummary'), true),
    new ReportButton(this.months[this.reportableMonths[2]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[2], 'CMSummary'), true),
    new ReportButton(this.months[this.reportableMonths[3]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[3], 'CMSummary'), true),
    new ReportButton(this.months[this.reportableMonths[4]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[4], 'CMSummary'), true),
    new ReportButton(this.months[this.reportableMonths[5]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[5], 'CMSummary'), true),
    new ReportButton(this.months[this.reportableMonths[6]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[6], 'CMSummary'), true)
  ];
  comprehensiveReportYearButtons: ReportButton[] = [
    new ReportButton(this.reportableYears[0].toString(), 'btn-outline-primary', () => this.quickTonnageReportByYear(this.reportableYears[0], 'CMSummary'), true),
    new ReportButton(this.reportableYears[1].toString(), 'btn-outline-secondary', () => this.quickTonnageReportByYear(this.reportableYears[1], 'CMSummary'), true),
    new ReportButton(this.reportableYears[2].toString(), 'btn-outline-secondary', () => this.quickTonnageReportByYear(this.reportableYears[2], 'CMSummary'), true),
    new ReportButton(this.reportableYears[3].toString(), 'btn-outline-secondary', () => this.quickTonnageReportByYear(this.reportableYears[3], 'CMSummary'), true),
    new ReportButton(this.reportableYears[4].toString(), 'btn-outline-secondary', () => this.quickTonnageReportByYear(this.reportableYears[4], 'CMSummary'), true)
  ];

  detailedDateFrom: Date = null;
  detailedDateTo: Date = null;
  detailedReportMonthButtons: ReportButton[] = [
    new ReportButton(this.months[this.reportableMonths[0]], 'btn-outline-primary', () => this.quickTonnageReportByMonth(this.reportableMonths[0], 'MTReport'), true),
    new ReportButton(this.months[this.reportableMonths[1]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[1], 'MTReport'), true),
    new ReportButton(this.months[this.reportableMonths[2]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[2], 'MTReport'), true),
    new ReportButton(this.months[this.reportableMonths[3]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[3], 'MTReport'), true),
    new ReportButton(this.months[this.reportableMonths[4]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[4], 'MTReport'), true),
    new ReportButton(this.months[this.reportableMonths[5]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[5], 'MTReport'), true),
    new ReportButton(this.months[this.reportableMonths[6]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[6], 'MTReport'), true)
  ];

  quantityDateFrom: Date = null;
  quantityDateTo: Date = null;
  quantityReportMonthButtons: ReportButton[] = [
    new ReportButton(this.months[this.reportableMonths[0]], 'btn-outline-primary', () => this.quickTonnageReportByMonth(this.reportableMonths[0], 'QTYReport'), true),
    new ReportButton(this.months[this.reportableMonths[1]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[1], 'QTYReport'), true),
    new ReportButton(this.months[this.reportableMonths[2]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[2], 'QTYReport'), true),
    new ReportButton(this.months[this.reportableMonths[3]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[3], 'QTYReport'), true),
    new ReportButton(this.months[this.reportableMonths[4]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[4], 'QTYReport'), true),
    new ReportButton(this.months[this.reportableMonths[5]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[5], 'QTYReport'), true),
    new ReportButton(this.months[this.reportableMonths[6]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[6], 'QTYReport'), true)
  ];

  incomeDateFrom: Date = null;
  incomeDateTo: Date = null;
  incomeReportMonthButtons: ReportButton[] = [
    new ReportButton(this.months[this.reportableMonths[0]], 'btn-outline-primary', () => this.quickTonnageReportByMonth(this.reportableMonths[0], 'TReport'), true),
    new ReportButton(this.months[this.reportableMonths[1]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[1], 'TReport'), true),
    new ReportButton(this.months[this.reportableMonths[2]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[2], 'TReport'), true),
    new ReportButton(this.months[this.reportableMonths[3]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[3], 'TReport'), true),
    new ReportButton(this.months[this.reportableMonths[4]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[4], 'TReport'), true),
    new ReportButton(this.months[this.reportableMonths[5]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[5], 'TReport'), true),
    new ReportButton(this.months[this.reportableMonths[6]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[6], 'TReport'), true)
  ];

  transactionDateFrom: Date = null;
  transactionDateTo: Date = null;
  transactionMonthButtons: ReportButton[] = [
    new ReportButton(this.months[this.reportableMonths[0]], 'btn-outline-primary', () => this.quickTransactionReportByMonth(this.reportableMonths[0], 'TransactionReport'), true),
    new ReportButton(this.months[this.reportableMonths[1]], 'btn-outline-secondary', () => this.quickTransactionReportByMonth(this.reportableMonths[1], 'TransactionReport'), true),
    new ReportButton(this.months[this.reportableMonths[2]], 'btn-outline-secondary', () => this.quickTransactionReportByMonth(this.reportableMonths[2], 'TransactionReport'), true),
    new ReportButton(this.months[this.reportableMonths[3]], 'btn-outline-secondary', () => this.quickTransactionReportByMonth(this.reportableMonths[3], 'TransactionReport'), true),
    new ReportButton(this.months[this.reportableMonths[4]], 'btn-outline-secondary', () => this.quickTransactionReportByMonth(this.reportableMonths[4], 'TransactionReport'), true),
    new ReportButton(this.months[this.reportableMonths[5]], 'btn-outline-secondary', () => this.quickTransactionReportByMonth(this.reportableMonths[5], 'TransactionReport'), true),
    new ReportButton(this.months[this.reportableMonths[6]], 'btn-outline-secondary', () => this.quickTransactionReportByMonth(this.reportableMonths[6], 'TransactionReport'), true)
  ];

  customerDateFrom: Date = null;
  customerDateTo: Date = null;
  customerReportMonthButtons: ReportButton[] = [
    new ReportButton(this.months[this.reportableMonths[0]], 'btn-outline-primary', () => this.quickTonnageReportByMonth(this.reportableMonths[0], 'CTReport'), true),
    new ReportButton(this.months[this.reportableMonths[1]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[1], 'CTReport'), true),
    new ReportButton(this.months[this.reportableMonths[2]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[2], 'CTReport'), true),
    new ReportButton(this.months[this.reportableMonths[3]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[3], 'CTReport'), true),
    new ReportButton(this.months[this.reportableMonths[4]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[4], 'CTReport'), true),
    new ReportButton(this.months[this.reportableMonths[5]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[5], 'CTReport'), true),
    new ReportButton(this.months[this.reportableMonths[6]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[6], 'CTReport'), true)
  ];

  annualReportYearButtons: ReportButton[] = [
    new ReportButton(this.reportableYears[0].toString(), 'btn-outline-primary', () => this.quickAnnualTonnageReport(this.reportableYears[0]), true),
    new ReportButton(this.reportableYears[1].toString(), 'btn-outline-secondary', () => this.quickAnnualTonnageReport(this.reportableYears[1]), true),
    new ReportButton(this.reportableYears[2].toString(), 'btn-outline-secondary', () => this.quickAnnualTonnageReport(this.reportableYears[2]), true),
    new ReportButton(this.reportableYears[3].toString(), 'btn-outline-secondary', () => this.quickAnnualTonnageReport(this.reportableYears[3]), true),
    new ReportButton(this.reportableYears[4].toString(), 'btn-outline-secondary', () => this.quickAnnualTonnageReport(this.reportableYears[4]), true)
  ];

  annualGridReportYearButtons: ReportButton[] = [
    new ReportButton(this.reportableYears[0].toString(), 'btn-outline-primary', () => this.quickAnnualGridTonnageReportByGrid(this.reportableYears[0]), true),
    new ReportButton(this.reportableYears[1].toString(), 'btn-outline-secondary', () => this.quickAnnualGridTonnageReportByGrid(this.reportableYears[1]), true),
    new ReportButton(this.reportableYears[2].toString(), 'btn-outline-secondary', () => this.quickAnnualGridTonnageReportByGrid(this.reportableYears[2]), true),
    new ReportButton(this.reportableYears[3].toString(), 'btn-outline-secondary', () => this.quickAnnualGridTonnageReportByGrid(this.reportableYears[3]), true),
    new ReportButton(this.reportableYears[4].toString(), 'btn-outline-secondary', () => this.quickAnnualGridTonnageReportByGrid(this.reportableYears[4]), true)
  ];

  comprehensiveAnnualReportYearButtons: ReportButton[] = [
    new ReportButton(this.reportableYears[0].toString(), 'btn-outline-primary', () => this.quickComprehensiveTonnageReport(this.reportableYears[0]), true),
    new ReportButton(this.reportableYears[1].toString(), 'btn-outline-secondary', () => this.quickComprehensiveTonnageReport(this.reportableYears[1]), true),
    new ReportButton(this.reportableYears[2].toString(), 'btn-outline-secondary', () => this.quickComprehensiveTonnageReport(this.reportableYears[2]), true),
    new ReportButton(this.reportableYears[3].toString(), 'btn-outline-secondary', () => this.quickComprehensiveTonnageReport(this.reportableYears[3]), true),
    new ReportButton(this.reportableYears[4].toString(), 'btn-outline-secondary', () => this.quickComprehensiveTonnageReport(this.reportableYears[4]), true)
  ];

  seasonalReportYearButtons: ReportButton[] = [
    new ReportButton(this.reportableYears[0].toString(), 'btn-outline-primary', () => this.quickSeasonalTonnageReport(this.reportableYears[0], 'STReport'), true),
    new ReportButton(this.reportableYears[1].toString(), 'btn-outline-secondary', () => this.quickSeasonalTonnageReport(this.reportableYears[1], 'STReport'), true),
    new ReportButton(this.reportableYears[2].toString(), 'btn-outline-secondary', () => this.quickSeasonalTonnageReport(this.reportableYears[2], 'STReport'), true),
    new ReportButton(this.reportableYears[3].toString(), 'btn-outline-secondary', () => this.quickSeasonalTonnageReport(this.reportableYears[3], 'STReport'), true),
    new ReportButton(this.reportableYears[4].toString(), 'btn-outline-secondary', () => this.quickSeasonalTonnageReport(this.reportableYears[4], 'STReport'), true)
  ];

  excelDateFrom: Date = null;
  excelDateTo: Date = null;
  excelReportMonthButtons: ReportButton[] = [
    new ReportButton(this.months[this.reportableMonths[0]], 'btn-outline-primary', () => this.quickTonnageReportByMonth(this.reportableMonths[0], 'EReport'), true),
    new ReportButton(this.months[this.reportableMonths[1]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[1], 'EReport'), true),
    new ReportButton(this.months[this.reportableMonths[2]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[2], 'EReport'), true),
    new ReportButton(this.months[this.reportableMonths[3]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[3], 'EReport'), true),
    new ReportButton(this.months[this.reportableMonths[4]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[4], 'EReport'), true),
    new ReportButton(this.months[this.reportableMonths[5]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[5], 'EReport'), true),
    new ReportButton(this.months[this.reportableMonths[6]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[6], 'EReport'), true)
  ];
  excelReportYearButtons: ReportButton[] = [
    new ReportButton(this.reportableYears[0].toString(), 'btn-outline-primary', () => this.quickTonnageReportByYear(this.reportableYears[0], 'EReport'), true),
    new ReportButton(this.reportableYears[1].toString(), 'btn-outline-secondary', () => this.quickTonnageReportByYear(this.reportableYears[1], 'EReport'), true),
    new ReportButton(this.reportableYears[2].toString(), 'btn-outline-secondary', () => this.quickTonnageReportByYear(this.reportableYears[2], 'EReport'), true),
    new ReportButton(this.reportableYears[3].toString(), 'btn-outline-secondary', () => this.quickTonnageReportByYear(this.reportableYears[3], 'EReport'), true),
    new ReportButton(this.reportableYears[4].toString(), 'btn-outline-secondary', () => this.quickTonnageReportByYear(this.reportableYears[4], 'EReport'), true)
  ];

  seasonalExcelReportYearButtons: ReportButton[] = [
    new ReportButton(this.reportableYears[0].toString(), 'btn-outline-primary', () => this.quickSeasonalTonnageReport(this.reportableYears[0], 'SEReport'), true),
    new ReportButton(this.reportableYears[1].toString(), 'btn-outline-secondary', () => this.quickSeasonalTonnageReport(this.reportableYears[1], 'SEReport'), true),
    new ReportButton(this.reportableYears[2].toString(), 'btn-outline-secondary', () => this.quickSeasonalTonnageReport(this.reportableYears[2], 'SEReport'), true),
    new ReportButton(this.reportableYears[3].toString(), 'btn-outline-secondary', () => this.quickSeasonalTonnageReport(this.reportableYears[3], 'SEReport'), true),
    new ReportButton(this.reportableYears[4].toString(), 'btn-outline-secondary', () => this.quickSeasonalTonnageReport(this.reportableYears[4], 'SEReport'), true)
  ];

  tonnageSummaryExcelDateFrom: Date = null;
  tonnageSummaryExcelDateTo: Date = null;
  tonnageSummaryExcelReportMonthButtons: ReportButton[] = [
    new ReportButton(this.months[this.reportableMonths[0]], 'btn-outline-primary', () => this.quickTonnageReportByMonth(this.reportableMonths[0], 'TSEReport'), true),
    new ReportButton(this.months[this.reportableMonths[1]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[1], 'TSEReport'), true),
    new ReportButton(this.months[this.reportableMonths[2]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[2], 'TSEReport'), true),
    new ReportButton(this.months[this.reportableMonths[3]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[3], 'TSEReport'), true),
    new ReportButton(this.months[this.reportableMonths[4]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[4], 'TSEReport'), true),
    new ReportButton(this.months[this.reportableMonths[5]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[5], 'TSEReport'), true),
    new ReportButton(this.months[this.reportableMonths[6]], 'btn-outline-secondary', () => this.quickTonnageReportByMonth(this.reportableMonths[6], 'TSEReport'), true)
  ];
  tonnageSummaryExcelReportYearButtons: ReportButton[] = [
    new ReportButton(this.reportableYears[0].toString(), 'btn-outline-primary', () => this.quickTonnageReportByYear(this.reportableYears[0], 'TSEReport'), true),
    new ReportButton(this.reportableYears[1].toString(), 'btn-outline-secondary', () => this.quickTonnageReportByYear(this.reportableYears[1], 'TSEReport'), true),
    new ReportButton(this.reportableYears[2].toString(), 'btn-outline-secondary', () => this.quickTonnageReportByYear(this.reportableYears[2], 'TSEReport'), true),
    new ReportButton(this.reportableYears[3].toString(), 'btn-outline-secondary', () => this.quickTonnageReportByYear(this.reportableYears[3], 'TSEReport'), true),
    new ReportButton(this.reportableYears[4].toString(), 'btn-outline-secondary', () => this.quickTonnageReportByYear(this.reportableYears[4], 'TSEReport'), true)
  ];

  invoiceDateFrom: Date = null;
  invoiceDateTo: Date = null;
  invoiceReportMonthButtons: ReportButton[] = [
    new ReportButton(this.months[this.reportableMonths[0]], 'btn-outline-primary', () => this.quickInvoiceReportByMonth(this.reportableMonths[0], 'STLReport'), true),
    new ReportButton(this.months[this.reportableMonths[1]], 'btn-outline-secondary', () => this.quickInvoiceReportByMonth(this.reportableMonths[1], 'STLReport'), true),
    new ReportButton(this.months[this.reportableMonths[2]], 'btn-outline-secondary', () => this.quickInvoiceReportByMonth(this.reportableMonths[2], 'STLReport'), true),
    new ReportButton(this.months[this.reportableMonths[3]], 'btn-outline-secondary', () => this.quickInvoiceReportByMonth(this.reportableMonths[3], 'STLReport'), true),
    new ReportButton(this.months[this.reportableMonths[4]], 'btn-outline-secondary', () => this.quickInvoiceReportByMonth(this.reportableMonths[4], 'STLReport'), true),
    new ReportButton(this.months[this.reportableMonths[5]], 'btn-outline-secondary', () => this.quickInvoiceReportByMonth(this.reportableMonths[5], 'STLReport'), true),
    new ReportButton(this.months[this.reportableMonths[6]], 'btn-outline-secondary', () => this.quickInvoiceReportByMonth(this.reportableMonths[6], 'STLReport'), true)
  ];
  singleInvoice = false;
  singleCustomer = false;
  forAllCustomers = false;

  paymentTotalsDateFrom: Date = null;
  paymentTotalsDateTo: Date = null;
  paymentTotalsReportMonthButtons: ReportButton[] = [
    new ReportButton(this.months[this.reportableMonths[0]], 'btn-outline-primary', () => this.quickPaymentTotalsReportByMonth(this.reportableMonths[0]), true),
    new ReportButton(this.months[this.reportableMonths[1]], 'btn-outline-secondary', () => this.quickPaymentTotalsReportByMonth(this.reportableMonths[1]), true),
    new ReportButton(this.months[this.reportableMonths[2]], 'btn-outline-secondary', () => this.quickPaymentTotalsReportByMonth(this.reportableMonths[2]), true),
    new ReportButton(this.months[this.reportableMonths[3]], 'btn-outline-secondary', () => this.quickPaymentTotalsReportByMonth(this.reportableMonths[3]), true),
    new ReportButton(this.months[this.reportableMonths[4]], 'btn-outline-secondary', () => this.quickPaymentTotalsReportByMonth(this.reportableMonths[4]), true),
    new ReportButton(this.months[this.reportableMonths[5]], 'btn-outline-secondary', () => this.quickPaymentTotalsReportByMonth(this.reportableMonths[5]), true),
    new ReportButton(this.months[this.reportableMonths[6]], 'btn-outline-secondary', () => this.quickPaymentTotalsReportByMonth(this.reportableMonths[6]), true)
  ];
  paymentTotalsReportYearButtons: ReportButton[] = [
    new ReportButton(this.reportableYears[0].toString(), 'btn-outline-primary', () => this.quickPaymentTotalsReportByYear(this.reportableYears[0]), true),
    new ReportButton(this.reportableYears[1].toString(), 'btn-outline-secondary', () => this.quickPaymentTotalsReportByYear(this.reportableYears[1]), true),
    new ReportButton(this.reportableYears[2].toString(), 'btn-outline-secondary', () => this.quickPaymentTotalsReportByYear(this.reportableYears[2]), true),
    new ReportButton(this.reportableYears[3].toString(), 'btn-outline-secondary', () => this.quickPaymentTotalsReportByYear(this.reportableYears[3]), true),
    new ReportButton(this.reportableYears[4].toString(), 'btn-outline-secondary', () => this.quickPaymentTotalsReportByYear(this.reportableYears[4]), true)

  ];

  invoiceTotalsDateFrom: Date = null;
  invoiceTotalsDateTo: Date = null;
  invoiceTotalsReportMonthButtons: ReportButton[] = [
    new ReportButton(this.months[this.reportableMonths[0]], 'btn-outline-primary', () => this.quickInvoiceTotalsReportByMonth(this.reportableMonths[0]), true),
    new ReportButton(this.months[this.reportableMonths[1]], 'btn-outline-secondary', () => this.quickInvoiceTotalsReportByMonth(this.reportableMonths[1]), true),
    new ReportButton(this.months[this.reportableMonths[2]], 'btn-outline-secondary', () => this.quickInvoiceTotalsReportByMonth(this.reportableMonths[2]), true),
    new ReportButton(this.months[this.reportableMonths[3]], 'btn-outline-secondary', () => this.quickInvoiceTotalsReportByMonth(this.reportableMonths[3]), true),
    new ReportButton(this.months[this.reportableMonths[4]], 'btn-outline-secondary', () => this.quickInvoiceTotalsReportByMonth(this.reportableMonths[4]), true),
    new ReportButton(this.months[this.reportableMonths[5]], 'btn-outline-secondary', () => this.quickInvoiceTotalsReportByMonth(this.reportableMonths[5]), true),
    new ReportButton(this.months[this.reportableMonths[6]], 'btn-outline-secondary', () => this.quickInvoiceTotalsReportByMonth(this.reportableMonths[6]), true)
  ];
  invoiceTotalsReportYearButtons: ReportButton[] = [
    new ReportButton(this.reportableYears[0].toString(), 'btn-outline-primary', () => this.quickInvoiceTotalsReportByYear(this.reportableYears[0]), true),
    new ReportButton(this.reportableYears[1].toString(), 'btn-outline-secondary', () => this.quickInvoiceTotalsReportByYear(this.reportableYears[1]), true),
    new ReportButton(this.reportableYears[2].toString(), 'btn-outline-secondary', () => this.quickInvoiceTotalsReportByYear(this.reportableYears[2]), true),
    new ReportButton(this.reportableYears[3].toString(), 'btn-outline-secondary', () => this.quickInvoiceTotalsReportByYear(this.reportableYears[3]), true),
    new ReportButton(this.reportableYears[4].toString(), 'btn-outline-secondary', () => this.quickInvoiceTotalsReportByYear(this.reportableYears[4]), true)

  ];

  subscriptionArray: Subscription[] = [];
  uomWatcherSubscription: Subscription;
  taxWatcherSubscription: Subscription;
  vehicleTypeWatcherSubscription: Subscription;

  tonnageReport: ReportSection = {
    title: 'Tonnage Report',
    divId: 'tonnageCollapse',
    default: true,
    monthlyReportFunction: this.quickTonnageReportByMonth,
    yearlyReportFunction: null,
    reportType: 'MTReport',
    preBuiltButtons: [],
    customReportButtons: [
      new ReportButton('Custom', 'btn-success', () => this.launchTonnageReportWizard('Tonnage Report', 'MTReport'))
    ]
  }

  quantityReport: ReportSection = {
    title: 'Material Quantity Report',
    divId: 'quantityCollapse',
    default: true,
    monthlyReportFunction: this.quickTonnageReportByMonth,
    yearlyReportFunction: null,
    reportType: 'QTYReport',
    preBuiltButtons: [],
    customReportButtons: [
      new ReportButton('Custom', 'btn-success', () => this.launchTonnageReportWizard('Material Quantity Report', 'QTYReport'))
    ]
  }

  tonnageReportWithPrice: ReportSection = {
    title: 'Tonnage Report with Price',
    divId: 'tonnageWithMoneyCollapse',
    default: false,
    monthlyReportFunction: this.quickTonnageReportByMonth,
    yearlyReportFunction: null,
    reportType: 'TReport',
    preBuiltButtons: [],
    customReportButtons: [
      new ReportButton('Custom', 'btn-success', () => this.launchTonnageReportWizard('Tonnage Report with Price', 'TReport'))
    ]
  };

  tonnageSummaryReport: ReportSection = {
    title: 'Tonnage Summary Report',
    divId: 'tonnageSummaryCollapse',
    default: false,
    monthlyReportFunction: this.quickTonnageReportByMonth,
    yearlyReportFunction: this.quickTonnageReportByYear,
    reportType: 'MTSummary',
    preBuiltButtons: [],
    customReportButtons: [
      new ReportButton('Custom', 'btn-success', () => this.launchTonnageReportWizard('Tonnage Summary Report', 'MTSummary'))
    ]
  }

  comprehensiveMaterialReport: ReportSection = {
    title: 'Comprehensive Material Report',
    divId: 'comprehenisveMaterialCollapse',
    default: false,
    monthlyReportFunction: this.quickTonnageReportByMonth,
    yearlyReportFunction: this.quickTonnageReportByYear,
    reportType: 'CMSummary',
    preBuiltButtons: [],
    customReportButtons: [
      new ReportButton('Custom', 'btn-success', () => this.launchTonnageReportWizard('Comprehnsive Material Report', 'CMSummary'))
    ]
  }

  seasonalTonnageReport: ReportSection = {
    title: 'Seasonal Tonnage Report',
    divId: 'tonnageSeasonalCollapse',
    default: false,
    monthlyReportFunction: null,
    yearlyReportFunction: this.quickSeasonalTonnageReport,
    reportType: 'STReport',
    preBuiltButtons: [],
    customReportButtons: [
      new ReportButton('Custom', 'btn-success', () => this.launchTonnageReportWizard('Seasonal Tonnage Report', 'STReport'))
    ]
  }

  tonnageReportByCustomer: ReportSection = {
    title: 'Tonnage Report By Customer',
    divId: 'tonnageCustomerCollapse',
    default: false,
    monthlyReportFunction: this.quickTonnageReportByMonth,
    yearlyReportFunction: null,
    reportType: 'CTReport',
    preBuiltButtons: [],
    customReportButtons: [
      new ReportButton('Custom', 'btn-success', () => this.launchTonnageReportWizard('Tonnage Report by Customer', 'CTReport'))
    ]
  }

  tonnageExcelReport: ReportSection = {
    title: 'Tonnage Excel Report',
    divId: 'tonnageExcelCollapse',
    default: false,
    monthlyReportFunction: this.quickTonnageReportByMonth,
    yearlyReportFunction: this.quickTonnageReportByYear,
    reportType: 'EReport',
    preBuiltButtons: [],
    customReportButtons: [
      new ReportButton('Custom', 'btn-success', () => this.launchTonnageReportWizard('Tonnage Excel Report', 'EReport'))
    ]
  }

  tonnageSummaryExcelReport: ReportSection = {
    title: 'Tonnage Summary Excel Report',
    divId: 'tonnageSummaryExcelCollapse',
    default: false,
    monthlyReportFunction: this.quickTonnageReportByMonth,
    yearlyReportFunction: this.quickTonnageReportByYear,
    reportType: 'TSEReport',
    preBuiltButtons: [],
    customReportButtons: [
      new ReportButton('Custom', 'btn-success', () => this.launchTonnageReportWizard('Tonnage Summary Excel Report', 'TSEReport'))
    ]
  }

  seasonalTonnageExcelReport: ReportSection = {
    title: 'Seasonal Tonnage Excel Report',
    divId: 'tonnageSeasonalExcelCollapse',
    default: false,
    monthlyReportFunction: null,
    yearlyReportFunction: this.quickSeasonalTonnageReport,
    reportType: 'SEReport',
    preBuiltButtons: [],
    customReportButtons: [
      new ReportButton('Custom', 'btn-success', () => this.launchTonnageReportWizard('Seasonal Tonnage Excel Report', 'SEReport'))
    ]
  }

  invoiceReport: ReportSection = {
    title: 'Invoice Report',
    divId: 'invoiceCollapse',
    default: true,
    monthlyReportFunction: this.quickInvoiceReportByMonth,
    yearlyReportFunction: null,
    reportType: 'STLReport',
    preBuiltButtons: [],
    customReportButtons: [
      new ReportButton('Single Invoice', 'btn-success', () => this.launchSingleInvoiceReport('single')),
      new ReportButton('Invoices by a Customer', 'btn-success', () => this.launchInvoiceReportWizard('singleCustomer')),
      new ReportButton('Invoices by all Customers', 'btn-success', () => this.launchInvoiceReportWizard('allCustomers')),
      // new ReportButton('Invoices by a Batch No', 'btn-success', () => this.launchInvoiceReportWizard('batch'))
    ]
  }

  monthlyReports: ReportSection[] = [
    this.tonnageReport,
    this.quantityReport,
    this.tonnageReportWithPrice,
    this.tonnageReportByCustomer,
    this.invoiceReport
  ];

  yearlyReports: ReportSection[] = [
    this.seasonalTonnageReport,
    this.seasonalTonnageExcelReport
  ];

  monthlyAndYearlyReports: ReportSection[] = [
    this.tonnageSummaryReport,
    this.tonnageExcelReport,
    this.tonnageSummaryExcelReport
  ];

  tonnageReports: ReportSection[] = [
    this.tonnageReport,
    this.quantityReport,
    this.tonnageReportWithPrice,
    this.tonnageSummaryReport,
    this.comprehensiveMaterialReport,
    this.seasonalTonnageReport,
    this.tonnageReportByCustomer,
    this.tonnageExcelReport,
    this.tonnageSummaryExcelReport,
    this.seasonalTonnageExcelReport,
    this.invoiceReport
  ];

  tonnageReportStrings: string[] = [
    'MTReport',
    'EReport',
    'CTReport',
    'MTSummary',
    'TReport',
    'QTYReport',
    'CMSmmary',
    'TSEReport'
  ]

  seasonalTonnageReportStrings: string[] = [
    'SEReport',
    'STReport'
  ]

  invoiceReportStrings: string[] = [
    'STLReport'
  ]

  reportSections: ReportSection[] = [
    ...this.tonnageReports
  ];

  constructor( public sbCmpMsgSvc: StarbaseComponentMessageService,
               protected modalSvc: StarbaseModalDialogService,
               public jobCodeService: LU_JobCodeService,
               public jobSvc: JobDataServiceBase,
               public gridModelService: LU_GridService,
               public contactDashSvc: STContactDataService,
               public contactTypeService: LU_ContactTypeService,
               public jobCategoryService: LU_JobCategoryService,
               public materialsServices: LU_MaterialServiceService,
               public taxModelService: LU_TaxService,
               public uomSvc: LU_UnitOfMeasureService,
               public vehicleTypeSvc: LU_VehicleTypeService,
               public vehicleSvc: VehicleDataService,
               public contactSvc: STContactDataService,
               public matSubCategorySvc: LU_MaterialSubCategoryService,
               public siteSvc: SiteDataService,
               public batchSvc: LU_InvoiceBatchService,
               public appGlobals: AppGlobalsService,
               public sbSvcProvider: StarbaseServicesProviderBase,
               public sthSvc: ScaleTicketHeaderServiceBase,
               public invoiceSvc: InvoiceDataService,
               public paymentSvc: PaymentService,
               public cd: ChangeDetectorRef,
               private loginSvc: StarbaseLoginService) {
  }

  focusElement(targetDivID: string) {
    setTimeout(() =>
    document.querySelector(`#${targetDivID}`)
      .scrollIntoView({ behavior: 'smooth', block: 'start' }), 500); // wait for collapse anim
  }

  updateActiveTables(data: { name: string, active: boolean }) {
    if (data.active) { // edit mode is active, so add the table if it isn't already in the list
      if (!this.activeTables.find(a => a === data.name)) {
        this.activeTables.push(data.name);
      }
    } else { // edit mode is finished, so remove the table from the list.
      this.activeTables.splice(this.activeTables.findIndex(a => a === data.name), 1);
    }
    this.handleEditComplete(data);
  }

  unsavedChangesCheck(): Observable<boolean> | boolean {
    if (!this.activeTables.length) {
      return true;
    }
    const obs$ = new Subject<boolean>();
    const modal =
      new StarbaseModalOptions(
        'Discard data changes?',
        `You have unsaved changes. If you leave now those changes will be lost.`,
        [
          new StarbaseModalButton(
            'Yes',
          () => { obs$.next(true); this.modalSvc.closeModal('User chose yes'); }),
          new StarbaseModalButton(
            'No',
            () => { obs$.next(false); this.modalSvc.closeModal('User chose no'); })
        ],
        StarbaseModalTypes.Warning
      );
    modal.dismissable = false;
    this.modalSvc.postModal(modal);
    return obs$;
  }

  ngOnInit() {
    this.isAdmin = this.loginSvc.getUserModel().isAdmin();
    this.currentUser = this.loginSvc.getUserModel();
    if (!this.appGlobals.currentUser || this.appGlobals.currentUser !== this.currentUser.user) {
      this.appGlobals.currentUser = this.currentUser.user;
    }

    this.darkMode = this.appGlobals.getStoredDarkModeSetting();
    this.glassMode = this.appGlobals.getStoredGlassModeSetting();

    this.reportSections = [];

    this.sthSvc.getStartYear().subscribe(y => {
      this.startYear = y;
      this.summaryReportYearButtons = this.summaryReportYearButtons.filter(b => +b.text >= this.startYear);
      this.annualReportYearButtons = this.annualReportYearButtons.filter(b => +b.text >= this.startYear);
      this.annualGridReportYearButtons = this.annualGridReportYearButtons.filter(b => +b.text >= this.startYear);
      this.MatQtySummaryReportYearButtons = this.MatQtySummaryReportYearButtons.filter(b => +b.text >= this.startYear);
      this.comprehensiveAnnualReportYearButtons = this.comprehensiveAnnualReportYearButtons.filter(b => +b.text >= this.startYear);
      this.seasonalReportYearButtons = this.seasonalReportYearButtons.filter(b => +b.text >= this.startYear);
      this.seasonalExcelReportYearButtons = this.seasonalExcelReportYearButtons.filter(b => +b.text >= this.startYear);
      this.excelReportYearButtons = this.excelReportYearButtons.filter(b => +b.text >= this.startYear);
      this.comprehensiveReportYearButtons = this.comprehensiveReportYearButtons.filter(b => +b.text >= this.startYear);
      this.tonnageSummaryExcelReportYearButtons = this.tonnageSummaryExcelReportYearButtons.filter(b => +b.text >= this.startYear);
      this.paymentTotalsReportYearButtons = this.paymentTotalsReportYearButtons.filter(b => +b.text >= this.startYear);
      this.invoiceTotalsReportYearButtons = this.invoiceTotalsReportYearButtons.filter(b => +b.text >= this.startYear);
    });

    this.dropdownTypeDebounceTime = this.appGlobals.dropdownTypeDebounceTime;

    this.subscriptionArray.push(this.uomWatcherSubscription);

    this.subscriptionArray.push(this.taxWatcherSubscription);

    if (this.appGlobals.getStoredDarkModeSetting()) {
      this.bsConfig.containerClass = 'theme-default';
    }
    this.statuses = ScaleTicketHeader.GetStatusEnum();
    this.materialsServices.getAllData(this.materialsServices.getAllUri).subscribe(m => {
      if (m && m.length) {
        this.materials = m.filter(x => x.requiresExitWeightInScaleTicket);
      }
    })
    this.materialsServices.getAllData(this.materialsServices.getAllUri).subscribe(m => {
      if (m && m.length) {
        this.allMaterials = m.filter(x => x.active);
      }
    });
    this.jobSvc.getAllData(this.jobSvc.getAllUri).subscribe(j => {
      if (j && j.length) {
        this.allJobs = j;
      }
    });
    this.contactSvc.getCustomers().subscribe(c => {
      if (c && c.length) {
        this.allCustomers = c;
      }
    });

    this.collapseTonnage = this.appGlobals.getReportSectionCollapseState('tonnage');
    this.collapseTonFinance = this.appGlobals.getReportSectionCollapseState('tonFinance');
    this.collapseInvoice = this.appGlobals.getReportSectionCollapseState('invoice');
    this.collapseFavorites = this.appGlobals.getReportSectionCollapseState('favorites');

    this.favoriteReports = this.appGlobals.getFavoriteReports();
    this.hasFavorites = this.favoriteReports.length > 0;

    this.siteSvc.getPrimarySite().subscribe((site) => {
      this.appGlobals.setSite(site);
      this.initLocation();
      this.cd.detectChanges();
    });
  }

  private initLocation() {
    if (this.appGlobals.site.enableMultiLocations && (!this.appGlobals.selectedLocation && !this.appGlobals.viewingAllLocations)) {
      const jwt = new JwtHelperService().decodeToken(this.loginSvc.getToken());
      this.appGlobals.currentUser = jwt["User"]; //Added so that the getDefaultLocation does not fail due to race condition
      const accessToAll = jwt["AccessToAllLocations"] === "True";

      if (typeof jwt["Locations"] === "string") {
        const loc = new LocationModel();
        loc.uid = parseInt(jwt["Locations"].split(":")[0]);
        loc.locationName = jwt["Locations"].split(":")[1];
        this.appGlobals.setAvailableLocations([loc], accessToAll);
        this.appGlobals.setSelectedLocation(loc, false);
      } else {
        this.appGlobals.setSelectedLocation(null, false);
        this.appGlobals.setAvailableLocations(jwt["Locations"].map((locStr: string) => {
          const l = new LocationModel();
          l.uid = parseInt(locStr.split(":")[0]);
          l.locationName = locStr.split(":")[1];
          return l;
        }), accessToAll);
        const dLocUID = this.appGlobals.getDefaultLocation();
        let dLocInAvailable: boolean = this.appGlobals.availableLocations.some(
          l => l.uid == dLocUID
        );
        if(!dLocInAvailable && dLocUID == 0 && accessToAll){
          dLocInAvailable = true;
        }
        if(dLocUID != null && dLocInAvailable){
          this.selectActiveLocation(this.appGlobals.availableLocations.find(l => l.uid === dLocUID),dLocUID == 0)
        } else {
          this.showLocationSelectModal();
        }
      }
    }
  }

  public showLocationSelectModal() {
    this.sbSvcProvider.overlaySvc.enableOverlay();
    const modal = new StarbaseModalOptions('Select Location', '', [], StarbaseModalTypes.Custom, this.locationSelectModal);
    modal.dismissable = false;
    modal.buttonControlsOverrideTemplate = this.emptyButtonOverrideTemplate;
    this.sbSvcProvider.modalSvc.postModal(modal);
  }

  public closeLocationSelectModal() {
    this.sbSvcProvider.overlaySvc.disableOverlay();
    if (this.sbSvcProvider.modalSvc.isCurrentlyModal()) {
      this
      this.sbSvcProvider.modalSvc.closeModal("closed location selection");
    }
  }

  public selectActiveLocation(loc: LocationModel, selectedAll: boolean) {
    this.closeLocationSelectModal();
    this.appGlobals.setSelectedLocation(loc, selectedAll);
    this.sbSvcProvider.notificationSvc.postNotification(
      this.sbSvcProvider.notificationSvc.notificationBuilder('Location Changed', `Your selected location has changed to ${loc ? loc.locationName : "ALL Locations"}`, undefined, 10_000, StarbaseNotificationSentiment.Info)
    );
  }

  ngOnDestroy() {
    this.subscriptionArray.forEach(
      (subscription) => {
        if (subscription) {
          subscription.unsubscribe();
        }
      }
    );
  }

  handleEditComplete(result) {
    if (!result.active) {
      switch (result.name) {
        case 'Contact Type':
          this.contactTypeService.triggerRefresh();
          break;
        case 'Grid':
          this.gridModelService.triggerRefresh();
          break;
        case 'Job Categories':
          this.jobCategoryService.triggerRefresh();
          break;
        case 'Job Codes':
          this.jobCodeService.triggerRefresh();
          break;
        case 'Materials Services':
          this.materialsServices.triggerRefresh();
          break;
        case 'Material Subcategories':
          this.matSubCategorySvc.triggerRefresh();
          break;
        case 'Taxes':
          this.taxModelService.triggerRefresh();
          break;
        case 'Unit of Measure':
          this.uomSvc.triggerRefresh();
          break;
        case 'Vehicle Type':
          this.vehicleTypeSvc.triggerRefresh();
          break;
        default:
          console.error('Edit Deactivate For Unkown Table');
      }
    }
  }

  warnForDateRange() {
    return this.monthlyReports.some(r => r.reportType == this.reportStyle);
  }

  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  isFieldEligibleForEdit(rowData, col: ITableColumn, editRow: boolean) {
    if (rowData.uid === 0) {
      return editRow && col.editableNew;
    } else {
      return editRow && col.editable;
    }
  }

  getDropdownData(col: DropdownTableColumn) {
    return col.dropdownData.eligibleArrayOfItems;
  }

  getDropdownDisplay(rowData, col: IDropdownTableColumn, editRow: boolean): string {
    return col.dropdownData.itemDisplayForRow(rowData, col.columnName, !editRow);
  }

  dropdownDisplay(item: ISelectable, col: IDropdownTableColumn | TableColumn): string {
    if ((col as IDropdownTableColumn).dropdownData) {
      return item[(col as IDropdownTableColumn).dropdownData.displayProperty];
    }
  }

  changeDropdownChosenItem(rowData, col: IDropdownTableColumn, item: ISelectable) {
    const bp = col.dropdownData.bindingProperty;
    rowData[col.columnName] = JSON.parse(JSON.stringify(item));
    rowData[col.outBindingProperty] = item[bp];
  }

  dateRangeChange(val: Date[]){
    this.filterDateFrom = val[0];
    this.filterDateTo = val[1];
    this.filterDateFrom.setHours(0, 0, 0, 0);
    this.filterDateTo.setHours(23, 59, 59, 999);
    return;
  }

  summaryDateRangeChange(val: Date[]){
    this.summaryDateFrom = val[0];
    this.summaryDateTo = val[1];
    this.summaryDateFrom.setHours(0, 0, 0, 0);
    this.summaryDateTo.setHours(23, 59, 59, 999);
    return;
  }

  MatQuantitySummaryDateRangeChange(val: Date[]){
    this.MatQtySummaryDateFrom = val[0];
    this.MatQtySummaryDateTo = val[1];
    this.MatQtySummaryDateFrom.setHours(0, 0, 0, 0);
    this.MatQtySummaryDateTo.setHours(23, 59, 59, 999);
    return;
  }

  comprehensiveDateRangeChange(val: Date[]){
    this.comprehensiveDateFrom = val[0];
    this.comprehensiveDateTo = val[1];
    this.comprehensiveDateFrom.setHours(0, 0, 0, 0);
    this.comprehensiveDateTo.setHours(23, 59, 59, 999);
    return;
  }

  detailedDateRangeChange(val: Date[]){
    this.detailedDateFrom = val[0];
    this.detailedDateTo = val[1];
    this.detailedDateFrom.setHours(0, 0, 0, 0);
    this.detailedDateTo.setHours(23, 59, 59, 999);
    return;
  }

  quantityDateRangeChange(val: Date[]){
    this.quantityDateFrom = val[0];
    this.quantityDateTo = val[1];
    this.quantityDateFrom.setHours(0, 0, 0, 0);
    this.quantityDateTo.setHours(23, 59, 59, 999);
    return;
  }

  incomeDateRangeChange(val: Date[]){
    this.incomeDateFrom = val[0];
    this.incomeDateTo = val[1];
    this.incomeDateFrom.setHours(0, 0, 0, 0);
    this.incomeDateTo.setHours(23, 59, 59, 999);
    return;
  }

  customerDateRangeChange(val: Date[]){
    this.customerDateFrom = val[0];
    this.customerDateTo = val[1];
    this.customerDateFrom.setHours(0, 0, 0, 0);
    this.customerDateTo.setHours(23, 59, 59, 999);
    return;
  }

  excelDateRangeChange(val: Date[]){
    this.excelDateFrom = val[0];
    this.excelDateTo = val[1];
    this.excelDateFrom.setHours(0, 0, 0, 0);
    this.excelDateTo.setHours(23, 59, 59, 999);
    return;
  }

  tonnageSummaryExcelDateRangeChange(val: Date[]){
  this.tonnageSummaryExcelDateFrom = val[0];
  this.tonnageSummaryExcelDateTo = val[1];
  this.tonnageSummaryExcelDateFrom.setHours(0, 0, 0, 0);
  this.tonnageSummaryExcelDateTo.setHours(23, 59, 59, 999);
  return;
}

  invoiceDateRangeChange(val: Date[]){
    this.invoiceDateFrom = val[0];
    this.invoiceDateTo = val[1];
    this.invoiceDateFrom.setHours(0, 0, 0, 0);
    this.invoiceDateTo.setHours(23, 59, 59, 999);
    return;
  }

  paymentTotalsDateRangeChange(val: Date[]){
    this.paymentTotalsDateFrom = val[0];
    this.paymentTotalsDateTo = val[1];
    this.paymentTotalsDateFrom.setHours(0, 0, 0, 0);
    this.paymentTotalsDateTo.setHours(23, 59, 59, 999);
    return;
  }

  invoiceTotalsDateRangeChange(val: Date[]){
    this.invoiceTotalsDateFrom = val[0];
    this.invoiceTotalsDateTo = val[1];
    this.invoiceTotalsDateFrom.setHours(0, 0, 0, 0);
    this.invoiceTotalsDateTo.setHours(23, 59, 59, 999);
    return;
  }

  transactionDateRangeChange(val: Date[]){
    this.transactionDateFrom = val[0];
    this.transactionDateTo = val[1];
    this.transactionDateFrom.setHours(0, 0, 0, 0);
    this.transactionDateTo.setHours(23, 59, 59, 999);
    return;
  }

  //Modified for All customers date range picker component
  dateRangeChangeForInvoices(val: Date[]) {
    if (!val) {
      this.filterDateFrom = null;
      this.filterDateTo = null;
      this.dateEntered = false;
    } else {
      this.filterDateFrom = val[0];
      this.filterDateTo = val[1];
      this.filterDateFrom.setHours(0, 0, 0, 0);
      this.filterDateTo.setHours(23, 59, 59, 999);
      this.dateEntered = true;
    }
    return;
  }

  selectCustomer(customer: STContact, hardSelect = false) {
    if (this.hardSelectLock) return;
    if (customer && hardSelect) {
      this.hardSelectLock = true;
      setTimeout(() => this.hardSelectLock = false, 500);
    }

    if (this.singleCustomer) {
      if (customer) {
        this.customer = customer;
      } else {
        this.customer = undefined;
      }
    }
    this.jobs = undefined;
    if (customer === null) {
      this.customers = [];
    } else if (customer.selected) {
      this.customers.push(customer);
    } else {
      this.customers = this.customers.filter(x => x.contactUID !== customer.contactUID);
    }
    this.jobs = this.allJobs.filter((j) => this.customers.some((c) => c.contactUID === j.jobContactUID));
  }

  selectAllCustomers() {
    this.jobs = undefined;
    this.customers = this.allCustomers;
    this.customers.forEach(x => x.selected = true);
    this.jobs = this.allJobs.filter((j) => this.customers.some((c) => c.contactUID === j.jobContactUID));
    if (this.customerSelect) {
      this.customerSelect.refreshData(this.customerSelect.filter, this.contactSvc.customerBroadSearchUri);
    }
  }

  selectJob(job: Job) {
    if (job === null) {
      this.jobs = [];
    } else if (job.selected) {
      this.jobs.push(job);
    } else {
      this.jobs = this.jobs.filter(x => x.uid !== job.uid);
    }
  }

  launchTonnageReportWizard(titleString: string, reportType: string){
    if (!this.isDownloading){
      this.reportTitle = titleString;
      this.sbSvcProvider.overlaySvc.enableOverlay();
      this.createTonnageReportWizOpen = true;
      if(reportType === "STReport" || reportType === "SEReport"){
        this.isSeasonal = true;
      }
      else{
        this.isSeasonal = false;
      }
      this.reportStyle = reportType
    }
  }

  launchQuantitySummaryReportWizard(titleString: string, reportType: string){
    if (!this.isDownloading){
      this.reportTitle = titleString;
      this.sbSvcProvider.overlaySvc.enableOverlay();
      this.createQuantityReportWizOpen = true;
      this.isSeasonal = false;
      this.reportStyle = reportType
    }
  }

  handleMatQtySummaryReportWizard(filter: FilterParams<ScaleTicketHeader>){
    if (filter) {
      this.appGlobals.addLocationFilters(filter);
      switch(this.reportStyle){
        case 'MatQtySummaryReport':
          this.generateQuantitySummaryReport(filter);
          break;
        case 'QTYReport':
          this.generateQuantityReport(filter);
          break;
      }
      this.createQuantityReportWizOpen = false;
      this.sbSvcProvider.overlaySvc.disableOverlay();
    }
    else{
      this.createQuantityReportWizOpen = false;
      this.sbSvcProvider.overlaySvc.disableOverlay();
    }
  }

  quickMatQtySummaryReportByMonth(month: number, reportType: string) {
    var dates = [];
    var yearAdjustment = month > this.currentMonth ? 1 : 0;
    dates.push(new Date(new Date().getFullYear() - yearAdjustment, month, 1));
    dates.push(month == 11 ? new Date(new Date().getFullYear() - yearAdjustment + 1, 0, 0, 23, 59, 59) : new Date( new Date().getFullYear() - yearAdjustment, month + 1, 0, 23, 59, 59));

    this.reportStyle = reportType;
    const filterParams = new FilterParams<ScaleTicketHeader>();
    filterParams.addToFilter('ScaleTicketDateInFrom', dates[0]);
    filterParams.addToFilter('ScaleTicketDateInTo', dates[1]);
    filterParams.addToFilter('ScaleTicketStatus', ScaleTicketStatusEnum.INVOICED.toString());
    filterParams.addToFilter('ScaleTicketStatus', ScaleTicketStatusEnum.UNBILLED.toString());

    this.appGlobals.addLocationFilters(filterParams);
    this.handleMatQtySummaryReportWizard(filterParams);
  }

  quickMatQtySummaryReportByYear(year: number, reportType: string) {
    var dates = [];
    dates.push(new Date());
    dates.push(new Date());
    dates[0].setYear(year);
    dates[0].setMonth(0);
    dates[0].setDate(1);
    dates[0].setHours(0);
    dates[0].setMinutes(0);
    dates[0].setSeconds(0);
    dates[1].setYear(year+1);
    dates[1].setMonth(0);
    dates[1].setDate(0);
    dates[1].setHours(23);
    dates[1].setMinutes(59);
    dates[1].setSeconds(59);

    this.reportStyle = reportType;
    const filterParams = new FilterParams<ScaleTicketHeader>();
    filterParams.addToFilter('ScaleTicketDateInFrom', dates[0]);
    filterParams.addToFilter('ScaleTicketDateInTo', dates[1]);
    filterParams.addToFilter('ScaleTicketStatus', ScaleTicketStatusEnum.INVOICED.toString());
    filterParams.addToFilter('ScaleTicketStatus', ScaleTicketStatusEnum.UNBILLED.toString());

    this.appGlobals.addLocationFilters(filterParams);
    this.handleMatQtySummaryReportWizard(filterParams);
  }

  quickMatQtySummaryReportByDateRange(reportType: string) {
    this.reportStyle = reportType;
    const filterParams = new FilterParams<ScaleTicketHeader>();
    filterParams.addToFilter('ScaleTicketDateInFrom', this.getFromDateByType(reportType));
    filterParams.addToFilter('ScaleTicketDateInTo', this.getToDateByType(reportType));
    filterParams.addToFilter('ScaleTicketStatus', ScaleTicketStatusEnum.INVOICED.toString());
    filterParams.addToFilter('ScaleTicketStatus', ScaleTicketStatusEnum.UNBILLED.toString());

    this.appGlobals.addLocationFilters(filterParams);
    this.handleMatQtySummaryReportWizard(filterParams);
  }

  quickTonnageReportByMonth(month: number, reportType: string) {
    var dates = [];
    var yearAdjustment = month > this.currentMonth ? 1 : 0;
    dates.push(new Date(new Date().getFullYear() - yearAdjustment, month, 1));
    dates.push(month == 11 ? new Date(new Date().getFullYear() - yearAdjustment + 1, 0, 0, 23, 59, 59) : new Date( new Date().getFullYear() - yearAdjustment, month + 1, 0, 23, 59, 59));

    this.reportStyle = reportType;
    const filterParams = new FilterParams<ScaleTicketHeader>();
    filterParams.addToFilter('ScaleTicketDateInFrom', dates[0]);
    filterParams.addToFilter('ScaleTicketDateInTo', dates[1]);
    filterParams.addToFilter('ScaleTicketStatus', ScaleTicketStatusEnum.INVOICED.toString());
    filterParams.addToFilter('ScaleTicketStatus', ScaleTicketStatusEnum.UNBILLED.toString());

    this.appGlobals.addLocationFilters(filterParams);
    this.handleTonnageReportWizard(filterParams);
  }

  quickTonnageReportByYear(year: number, reportType: string) {
    var dates = [];
    dates.push(new Date());
    dates.push(new Date());
    dates[0].setYear(year);
    dates[0].setMonth(0);
    dates[0].setDate(1);
    dates[0].setHours(0);
    dates[0].setMinutes(0);
    dates[0].setSeconds(0);
    dates[1].setYear(year+1);
    dates[1].setMonth(0);
    dates[1].setDate(0);
    dates[1].setHours(23);
    dates[1].setMinutes(59);
    dates[1].setSeconds(59);

    this.reportStyle = reportType;
    const filterParams = new FilterParams<ScaleTicketHeader>();
    filterParams.addToFilter('ScaleTicketDateInFrom', dates[0]);
    filterParams.addToFilter('ScaleTicketDateInTo', dates[1]);
    filterParams.addToFilter('ScaleTicketStatus', ScaleTicketStatusEnum.INVOICED.toString());
    filterParams.addToFilter('ScaleTicketStatus', ScaleTicketStatusEnum.UNBILLED.toString());

    this.appGlobals.addLocationFilters(filterParams);
    this.handleTonnageReportWizard(filterParams);
  }

  quickTonnageReportByDateRange(reportType: string) {
    this.reportStyle = reportType;
    const filterParams = new FilterParams<ScaleTicketHeader>();
    filterParams.addToFilter('ScaleTicketDateInFrom', this.getFromDateByType(reportType));
    filterParams.addToFilter('ScaleTicketDateInTo', this.getToDateByType(reportType));
    filterParams.addToFilter('ScaleTicketStatus', ScaleTicketStatusEnum.INVOICED.toString());
    filterParams.addToFilter('ScaleTicketStatus', ScaleTicketStatusEnum.UNBILLED.toString());
    this.appGlobals.addLocationFilters(filterParams);
    this.handleTonnageReportWizard(filterParams);
  }

  getFromDateByType(reportType: string) {
    switch (reportType) {
      case 'MTSummary':
        return this.summaryDateFrom;
      case 'MatQtySummaryReport':
        return this.MatQtySummaryDateFrom;
      case 'MTReport':
        return this.detailedDateFrom;
      case 'QTYReport':
        return this.quantityDateFrom;
      case 'TReport':
        return this.incomeDateFrom;
      case 'CTReport':
        return this.customerDateFrom;
      case 'EReport':
        return this.excelDateFrom;
      case 'TSEReport':
        return this.tonnageSummaryExcelDateFrom;
      case 'TransactionReport':
        return this.transactionDateFrom;
      case 'CMSummary':
        return this.comprehensiveDateFrom;
    }
  }

  getToDateByType(reportType: string) {
    switch (reportType) {
      case 'MTSummary':
        return this.summaryDateTo;
      case 'MatQtySummaryReport':
        return this.MatQtySummaryDateTo;
      case 'MTReport':
        return this.detailedDateTo;
      case 'QTYReport':
        return this.quantityDateTo;
      case 'TReport':
        return this.incomeDateTo;
      case 'CTReport':
        return this.customerDateTo;
      case 'EReport':
        return this.excelDateTo;
      case 'TSEReport':
        return this.tonnageSummaryExcelDateTo;
      case 'TransactionReport':
        return this.transactionDateTo;
      case 'CMSummary':
        return this.comprehensiveDateTo;
    }
  }

  quickTonnageReport(months: number, reportType: string){
    var dates = [];
    dates.push(new Date());
    dates.push(new Date());
    if (months == 0){
      dates[0].setMonth(dates[0].getMonth()-1);
      dates[0].setDate(1);
      dates[0].setHours(0);
      dates[0].setMinutes(0);
      dates[0].setSeconds(0);
      dates[1].setDate(0);
      dates[1].setHours(23);
      dates[1].setMinutes(59);
      dates[1].setSeconds(59);
    }
    else{
      dates[0].setMonth(dates[0].getMonth()-months);
      dates[0].setHours(0);
      dates[0].setMinutes(0);
      dates[0].setSeconds(0);
      dates[1].setHours(23);
      dates[1].setMinutes(59);
      dates[1].setSeconds(59);
    }
    this.reportStyle = reportType;
    const filterParams = new FilterParams<ScaleTicketHeader>();
    filterParams.addToFilter('ScaleTicketDateInFrom', dates[0]);
    filterParams.addToFilter('ScaleTicketDateInTo', dates[1]);
    filterParams.addToFilter('ScaleTicketStatus', ScaleTicketStatusEnum.INVOICED.toString());
    filterParams.addToFilter('ScaleTicketStatus', ScaleTicketStatusEnum.UNBILLED.toString());

    this.appGlobals.addLocationFilters(filterParams);
    this.handleTonnageReportWizard(filterParams);
  }

  quickSeasonalTonnageReport(year: number, reportType: string){
    var dates = [];
    dates.push(new Date());
    dates.push(new Date());
    dates[0].setYear(year-1);
    dates[0].setMonth(11);
    dates[0].setDate(1);
    dates[0].setHours(0);
    dates[0].setMinutes(0);
    dates[0].setSeconds(0);
    dates[1].setYear(year);
    dates[1].setMonth(11);
    dates[1].setDate(0);
    dates[1].setHours(23);
    dates[1].setMinutes(59);
    dates[1].setSeconds(59);
    this.reportStyle = reportType;
    const filterParams = new FilterParams<ScaleTicketHeader>();
    filterParams.addToFilter('ScaleTicketDateInFrom', dates[0]);
    filterParams.addToFilter('ScaleTicketDateInTo', dates[1]);
    filterParams.addToFilter('ScaleTicketStatus', ScaleTicketStatusEnum.INVOICED.toString());
    filterParams.addToFilter('ScaleTicketStatus', ScaleTicketStatusEnum.UNBILLED.toString());

    this.appGlobals.addLocationFilters(filterParams);
    this.handleTonnageReportWizard(filterParams);
  }

  quickAnnualTonnageReport(year: number) {
    var dates = [];
    dates.push(new Date());
    dates.push(new Date());
    dates[0].setYear(year);
    dates[0].setMonth(0);
    dates[0].setDate(1);
    dates[0].setHours(0);
    dates[0].setMinutes(0);
    dates[0].setSeconds(0);
    dates[1].setYear(year+1);
    dates[1].setMonth(0);
    dates[1].setDate(0);
    dates[1].setHours(23);
    dates[1].setMinutes(59);
    dates[1].setSeconds(59);
    const filterParams = new FilterParams<ScaleTicketHeader>();
    filterParams.addToFilter('ScaleTicketDateInFrom', dates[0]);
    filterParams.addToFilter('ScaleTicketDateInTo', dates[1]);
    filterParams.addToFilter('ScaleTicketStatus', ScaleTicketStatusEnum.INVOICED.toString());
    filterParams.addToFilter('ScaleTicketStatus', ScaleTicketStatusEnum.UNBILLED.toString());

    this.appGlobals.addLocationFilters(filterParams);
    this.generateAnnualTonnageReport(filterParams)
  }

  quickAnnualGridTonnageReportByGrid(year: number) {
    var dates = [];
    dates.push(new Date());
    dates.push(new Date());
    dates[0].setYear(year);
    dates[0].setMonth(0);
    dates[0].setDate(1);
    dates[0].setHours(0);
    dates[0].setMinutes(0);
    dates[0].setSeconds(0);
    dates[1].setYear(year+1);
    dates[1].setMonth(0);
    dates[1].setDate(0);
    dates[1].setHours(23);
    dates[1].setMinutes(59);
    dates[1].setSeconds(59);
    const filterParams = new FilterParams<ScaleTicketHeader>();
    filterParams.addToFilter('ScaleTicketDateInFrom', dates[0]);
    filterParams.addToFilter('ScaleTicketDateInTo', dates[1]);
    filterParams.addToFilter('ScaleTicketStatus', ScaleTicketStatusEnum.INVOICED.toString());
    filterParams.addToFilter('ScaleTicketStatus', ScaleTicketStatusEnum.UNBILLED.toString());

    this.appGlobals.addLocationFilters(filterParams);
    this.generateAnnualGridTonnageReport(filterParams);
  }

  quickComprehensiveTonnageReport(year: number) {
    var dates = [];
    dates.push(new Date());
    dates.push(new Date());
    dates[0].setYear(year);
    dates[0].setMonth(0);
    dates[0].setDate(1);
    dates[0].setHours(0);
    dates[0].setMinutes(0);
    dates[0].setSeconds(0);
    dates[1].setYear(year+1);
    dates[1].setMonth(0);
    dates[1].setDate(0);
    dates[1].setHours(23);
    dates[1].setMinutes(59);
    dates[1].setSeconds(59);
    const filterParams = new FilterParams<ScaleTicketHeader>();
    filterParams.addToFilter('ScaleTicketDateInFrom', dates[0]);
    filterParams.addToFilter('ScaleTicketDateInTo', dates[1]);
    filterParams.addToFilter('ScaleTicketStatus', ScaleTicketStatusEnum.INVOICED.toString());
    filterParams.addToFilter('ScaleTicketStatus', ScaleTicketStatusEnum.UNBILLED.toString());

    this.appGlobals.addLocationFilters(filterParams);
    this.generateAnnualComprehensiveTonnageReport(filterParams)
  }

  launchSingleInvoiceReport(caseChecker: string){
    this.singleInvoiceReportMode = true;
    this.sbSvcProvider.overlaySvc.enableOverlay();
    this.closeInvoiceSelectorBool = false;
  }

  closeInvoiceSelector(){
    this.closeInvoiceSelectorBool = true;
    this.sbSvcProvider.overlaySvc.disableOverlay();
  }

  generateInvoiceReportSingleSelect(data){
    if (this.selectedInvoice || data.invoiceNumber){
      if(!this.selectedInvoice){
        this.selectedInvoice = data;
      }

      const filterParams = new FilterParams<Invoice>();
      filterParams.addToFilter('InvoiceUID',this.selectedInvoice.uid)
      filterParams.addToFilter('Status',1);
      filterParams.addToFilter('Status',2);
      filterParams.addToFilter('Status',4);
      filterParams.addToFilter('Status',5);
      this.appGlobals.addLocationFilters(filterParams);

      if(this.selectedInvoice) {
        if (!this.isDownloading) {
          this.isDownloading = true;
          const genTicket$ = this.invoiceSvc.generateMultipleInvoicesReportpdf(filterParams).pipe(share()); //single invoice report.
          const notifier = new StarbaseNotificationObject(
            'Downloading...',
            null,
            StarbaseNotificationSentiment.Notice,
            null,
            genTicket$);
          genTicket$.subscribe(
            (content: any) => {
              const blob = new Blob([content], { type: 'application/pdf' });
              const downLink = document.createElement('a');
              downLink.href = window.URL.createObjectURL(blob);
              downLink.setAttribute('download', `Invoice Report ${new DatePipe('en-US').transform(new Date(), 'yyyy-MM-dd-HH-mm')}.pdf`);
              downLink.click();
              window.open(downLink.href, '_blank');
              this.isDownloading = false;
              this.cd.detectChanges();
              notifier.updateTitle('Success');
              notifier.updateContent('Report Successfully Generated');
            },
            (e) => {
              console.error(e);
              this.isDownloading = false;
              this.cd.detectChanges();
              notifier.updateTitle('Error');
              if(e.status === 404){
                notifier.updateContent('An error has occured.')
              }
              else{
                notifier.updateContent('Failed to Generate Report');
              }
            }
          );
          this.sbSvcProvider.notificationSvc.postNotification(notifier);
        }
      }
    }
  }

  selectInvoice(data: Invoice): void{
    if (data !== null) {
      this.selectedInvoice = data;
    } else {
      this.selectedInvoice = null;
    }
  }

  hardSelected(data: Invoice) {
    if (this.singleInvoiceReportMode ) {
      this.generateInvoiceReportSingleSelect(data);
      this.closeInvoiceDatePicker();
    }
  }

  selectAllInvoices(invoices: Invoice){
  }

  quickInvoiceReportByMonth(month: number, reportType: string) {
    var dates = [];
    var yearAdjustment = month > this.currentMonth ? 1 : 0;
    dates.push(new Date(new Date().getFullYear() - yearAdjustment, month, 1));
    dates.push(month == 11 ? new Date(new Date().getFullYear() - yearAdjustment + 1, 0, 0, 23, 59, 59) : new Date( new Date().getFullYear() - yearAdjustment, month + 1, 0, 23, 59, 59));

    this.reportStyle = reportType;
    const filterParams = new FilterParams<ScaleTicketHeader>();
    filterParams.addToFilter('ScaleTicketDateInFrom', dates[0]);
    filterParams.addToFilter('ScaleTicketDateInTo', dates[1]);
    this.handleInvoiceReportWizard(filterParams);
  }

  quickInvoiceReportByDateRange(reportType: string) {
    this.reportStyle = reportType;
    const filterParams = new FilterParams<ScaleTicketHeader>();
    filterParams.addToFilter('ScaleTicketDateInFrom', this.invoiceDateFrom);
    filterParams.addToFilter('ScaleTicketDateInTo', this.invoiceDateTo);
    this.handleInvoiceReportWizard(filterParams);
  }

  quickPaymentTotalsReport(byDateRange = false) {
    const filterParams = new FilterParams<Payment>();
    if (byDateRange) {
      filterParams.addToFilter('PaymentDateInFrom', this.paymentTotalsDateFrom);
      filterParams.addToFilter('PaymentDateInTo', this.paymentTotalsDateTo);
    }

    filterParams.setFirstSort("Customer.Organization");
    filterParams.addToFilter('Pending', false);
    filterParams.addToFilter('PaymentVoided', false);

    this.generatePaymentTotalsReport(filterParams);
  }

  quickPaymentTotalsReportByMonth(month: number) {
    var dates = [];
    var yearAdjustment = month > this.currentMonth ? 1 : 0;
    dates.push(new Date(new Date().getFullYear() - yearAdjustment, month, 1));
    dates.push(month == 11 ? new Date(new Date().getFullYear() - yearAdjustment + 1, 0, 0, 23, 59, 59) : new Date( new Date().getFullYear() - yearAdjustment, month + 1, 0, 23, 59, 59));

    const filterParams = new FilterParams<Payment>();
    filterParams.addToFilter('PaymentDateInFrom', dates[0]);
    filterParams.addToFilter('PaymentDateInTo', dates[1]);
    filterParams.setFirstSort("Customer.Organization");
    filterParams.addToFilter('Pending', false);
    filterParams.addToFilter('PaymentVoided', false);

    this.appGlobals.addLocationFilters(filterParams);
    this.generatePaymentTotalsReport(filterParams);
  }

  quickPaymentTotalsReportByYear(year: number) {
    var dates = [];
    dates.push(new Date());
    dates.push(new Date());
    dates[0].setYear(year);
    dates[0].setMonth(0);
    dates[0].setDate(1);
    dates[0].setHours(0);
    dates[0].setMinutes(0);
    dates[0].setSeconds(0);
    dates[1].setYear(year+1);
    dates[1].setMonth(0);
    dates[1].setDate(0);
    dates[1].setHours(23);
    dates[1].setMinutes(59);
    dates[1].setSeconds(59);

    const filterParams = new FilterParams<Payment>();
    filterParams.addToFilter('PaymentDateInFrom', dates[0]);
    filterParams.addToFilter('PaymentDateInTo', dates[1]);
    filterParams.setFirstSort("Customer.Organization");
    filterParams.addToFilter('Pending', false);
    filterParams.addToFilter('PaymentVoided', false);

    this.appGlobals.addLocationFilters(filterParams);
    this.generatePaymentTotalsReport(filterParams);
  }

  generatePaymentTotalsReport(filter: FilterParams<Payment>){
    if (!this.isDownloading) {
      this.isDownloading = true;
      this.dateEntered = false;
      this.appGlobals.addLocationFilters(filter);
      const genTicket$ = this.paymentSvc.generatePaymentTotalsPDF(filter).pipe(share());
      const notifier = new StarbaseNotificationObject(
        'Downloading...',
        null,
        StarbaseNotificationSentiment.Notice,
        null,
        genTicket$);
      genTicket$.subscribe(
        (content: any) => {
          const blob = new Blob([content], { type: 'application/pdf' });
          const downLink = document.createElement('a');
          downLink.href = window.URL.createObjectURL(blob);
          downLink.setAttribute('download', `Customer Payment Totals Report ${new DatePipe('en-US').transform(new Date(), 'yyyy-MM-dd-HH-mm')}.pdf`);
          downLink.click();
          window.open(downLink.href, '_blank');
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Success');
          notifier.updateContent('Report Successfully Generated');
        },
        (e) => {
          console.error(e);
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Error');
          if(e.status == 404){
            notifier.updateContent('An error has occured.')
          }
          else{
            notifier.updateContent('Failed to Generate Report');
          }
        }
      );
      this.sbSvcProvider.notificationSvc.postNotification(notifier);
    }
  }

  quickInvoiceTotalsReport(byDateRange = false) {
    const filterParams = new FilterParams<Invoice>();
    if (byDateRange) {
      filterParams.addToFilter('ScaleTicketDateInFrom', this.invoiceTotalsDateFrom);
      filterParams.addToFilter('ScaleTicketDateInTo', this.invoiceTotalsDateTo);
    }

    filterParams.setFirstSort("Customer.Organization");
    filterParams.addToFilter('Pending', false);

    this.generateInvoiceTotalsReport(filterParams);
  }

  quickInvoiceTotalsReportByMonth(month: number) {
    var dates = [];
    var yearAdjustment = month > this.currentMonth ? 1 : 0;
    dates.push(new Date(new Date().getFullYear() - yearAdjustment, month, 1));
    dates.push(month == 11 ? new Date(new Date().getFullYear() - yearAdjustment + 1, 0, 0, 23, 59, 59) : new Date( new Date().getFullYear() - yearAdjustment, month + 1, 0, 23, 59, 59));

    const filterParams = new FilterParams<Invoice>();
    filterParams.addToFilter('ScaleTicketDateInFrom', dates[0]);
    filterParams.addToFilter('ScaleTicketDateInTo', dates[1]);
    filterParams.setFirstSort("Customer.Organization");
    filterParams.addToFilter('Pending', false);

    this.appGlobals.addLocationFilters(filterParams);
    this.generateInvoiceTotalsReport(filterParams);
  }

  quickInvoiceTotalsReportByYear(year: number) {
    var dates = [];
    dates.push(new Date());
    dates.push(new Date());
    dates[0].setYear(year);
    dates[0].setMonth(0);
    dates[0].setDate(1);
    dates[0].setHours(0);
    dates[0].setMinutes(0);
    dates[0].setSeconds(0);
    dates[1].setYear(year+1);
    dates[1].setMonth(0);
    dates[1].setDate(0);
    dates[1].setHours(23);
    dates[1].setMinutes(59);
    dates[1].setSeconds(59);

    const filterParams = new FilterParams<Invoice>();
    filterParams.addToFilter('ScaleTicketDateInFrom', dates[0]);
    filterParams.addToFilter('ScaleTicketDateInTo', dates[1]);
    filterParams.setFirstSort("Customer.Organization");
    filterParams.addToFilter('Pending', false);

    this.appGlobals.addLocationFilters(filterParams);
    this.generateInvoiceTotalsReport(filterParams);
  }

  generateInvoiceTotalsReport(filter: FilterParams<Invoice>){
    if (!this.isDownloading) {
      this.isDownloading = true;
      this.dateEntered = false;
      this.appGlobals.addLocationFilters(filter);
      const genTicket$ = this.invoiceSvc.generateInvoiceTotalsPDF(filter).pipe(share());
      const notifier = new StarbaseNotificationObject(
        'Downloading...',
        null,
        StarbaseNotificationSentiment.Notice,
        null,
        genTicket$);
      genTicket$.subscribe(
        (content: any) => {
          const blob = new Blob([content], { type: 'application/pdf' });
          const downLink = document.createElement('a');
          downLink.href = window.URL.createObjectURL(blob);
          downLink.setAttribute('download', `Customer Invoice Totals Report ${new DatePipe('en-US').transform(new Date(), 'yyyy-MM-dd-HH-mm')}.pdf`);
          downLink.click();
          window.open(downLink.href, '_blank');
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Success');
          notifier.updateContent('Report Successfully Generated');
        },
        (e) => {
          console.error(e);
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Error');
          if(e.status == 404){
            notifier.updateContent('An error has occured.')
          }
          else{
            notifier.updateContent('Failed to Generate Report');
          }
        }
      );
      this.sbSvcProvider.notificationSvc.postNotification(notifier);
    }
  }

  quickTransactionReportByMonth(month: number, reportType: string) {
    var dates = [];
    var yearAdjustment = month > this.currentMonth ? 1 : 0;
    dates.push(new Date(new Date().getFullYear() - yearAdjustment, month, 1));
    dates.push(month == 11 ? new Date(new Date().getFullYear() - yearAdjustment + 1, 0, 0, 23, 59, 59) : new Date( new Date().getFullYear() - yearAdjustment, month + 1, 0, 23, 59, 59));

    this.reportStyle = reportType;
    const filterParams = new FilterParams<Invoice>();
    filterParams.addToFilter('ScaleTicketDateInFrom', dates[0]);
    filterParams.addToFilter('ScaleTicketDateInTo', dates[1]);
    filterParams.addToFilter('ScaleTicketStatus', ScaleTicketStatusEnum.INVOICED.toString());
    filterParams.addToFilter('ScaleTicketStatus', ScaleTicketStatusEnum.UNBILLED.toString());
    this.handleTransactionReportWizard(filterParams);
  }

  quickTransactionReportByDateRange(reportType: string) {
    this.reportStyle = reportType;
    const filterParams = new FilterParams<Invoice>();
    filterParams.addToFilter('ScaleTicketDateInFrom', this.transactionDateFrom);
    filterParams.addToFilter('ScaleTicketDateInTo', this.transactionDateTo);
    this.handleTransactionReportWizard(filterParams);
  }

  handleTransactionReportWizard(filter: FilterParams<Invoice>){
    if(filter) {
      this.dateEntered = true;
      this.generateTransactionReport(filter);
      this.createTransactionReportWizOpen = false;
      this.sbSvcProvider.overlaySvc.disableOverlay();
    } else {
      this.createTransactionReportWizOpen = false;
      this.sbSvcProvider.overlaySvc.disableOverlay();
    }
  }

  generateTransactionReport(filter: FilterParams<Invoice>){
    if (!this.isDownloading && this.dateEntered) {
      this.isDownloading = true;
      this.dateEntered = false;
      this.appGlobals.addLocationFilters(filter);
      const genTicket$ = this.invoiceSvc.generateTransactionReportPDF(filter).pipe(share());
      const notifier = new StarbaseNotificationObject(
        'Downloading...',
        null,
        StarbaseNotificationSentiment.Notice,
        null,
        genTicket$);
      genTicket$.subscribe(
        (content: any) => {
          const blob = new Blob([content], { type: 'application/pdf' });
          const downLink = document.createElement('a');
          downLink.href = window.URL.createObjectURL(blob);
          downLink.setAttribute('download', `Transaction Report ${new DatePipe('en-US').transform(new Date(), 'yyyy-MM-dd-HH-mm')}.pdf`);
          downLink.click();
          window.open(downLink.href, '_blank');
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Success');
          notifier.updateContent('Report Successfully Generated');
        },
        (e) => {
          console.error(e);
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Error');
          if(e.status == 404){
            notifier.updateContent('No Data to Report')
          }
          else{
            notifier.updateContent('Failed to Generate Report');
          }
        }
      );

      this.sbSvcProvider.notificationSvc.postNotification(notifier);
      }
  }

  quickInvoiceReport(months: number, reportType: string){
    var dates = [];
    dates.push(new Date());
    dates.push(new Date());
    if (months == 0){
      dates[0].setMonth(dates[0].getMonth()-1);
      dates[0].setDate(1);
      dates[0].setHours(0);
      dates[0].setMinutes(0);
      dates[0].setSeconds(0);
      dates[1].setDate(0);
      dates[1].setHours(23);
      dates[1].setMinutes(59);
      dates[1].setSeconds(59);
    }
    else{
      dates[0].setMonth(dates[0].getMonth()-months);
      dates[0].setHours(0);
      dates[0].setMinutes(0);
      dates[0].setSeconds(0);
      dates[1].setHours(23);
      dates[1].setMinutes(59);
      dates[1].setSeconds(59);
    }

    this.reportStyle = reportType;
    const filterParams = new FilterParams<ScaleTicketHeader>();
    this.appGlobals.addLocationFilters(filterParams);
    filterParams.addToFilter('ScaleTicketDateInFrom', dates[0]);
    filterParams.addToFilter('ScaleTicketDateInTo', dates[1]);
    this.handleInvoiceReportWizard(filterParams);
  }

  closeInvoiceDatePicker(){
    this.datePickerModalForInvoiceOpen = false;
    this.selectedInvoice = null;
    this.customer = null;
    this.filterDateFrom = null;
    this.filterDateTo = null;
    this.sbSvcProvider.overlaySvc.disableOverlay();
  }

  closeInvoiceAgingDetailDatePicker(){
    this.invoiceAgingDetailModalOpen = false;
    this.selectedInvoice = null;
    this.customer = null;
    this.filterDateFrom = null;
    this.filterDateTo = null;
    this.sbSvcProvider.overlaySvc.disableOverlay();
  }

  closeCustomerStatement(){
    this.customerStatementModalOpen = false;
    this.selectedInvoice = null;
    this.customer = null;
    this.filterDateFrom = null;
    this.filterDateTo = null;
    this.sbSvcProvider.overlaySvc.disableOverlay();
  }

  customInvoiceReportValid(): boolean {
    return (this.singleInvoice && !!this.selectedInvoice) || (this.singleCustomer && !!this.filterDateFrom && !!this.filterDateTo && !!this.customer) || (this.forAllCustomers && !!this.filterDateFrom && !!this.filterDateTo);
  }

  displayDateRangeWarning(fromDate: Date, toDate: Date) {
    return fromDate && toDate && Math.floor((toDate.getTime() - fromDate.getTime()) / 86400000) > 31;
  }

  generateCustomInvoiceReport() {
    if (this.singleInvoice) {
      this.generateInvoiceReportSingleSelect(undefined);
      this.closeInvoiceDatePicker();
    } else if (this.singleCustomer) {
      const filter = new FilterParams<ScaleTicketHeader>();
      filter.setFirstSort("Job.JobContact.Organization");
      filter.addToSorts("Job.JobDescription");
      filter.addToFilter('Status',1);
      filter.addToFilter('Status',2);
      filter.addToFilter('Status',4);
      filter.addToFilter('Status',5);
      filter.addToFilter('Job.JobContactUID', this.customer.contactUID);
      filter.addToFilter('ScaleTicketDateInFrom', this.filterDateFrom);
      filter.addToFilter('ScaleTicketDateInTo', this.filterDateTo);
      this.generateInvoiceReport(filter);
      this.closeInvoiceDatePicker();

    } else if (this.forAllCustomers) {
      const filterParams = new FilterParams<ScaleTicketHeader>();
      filterParams.addToFilter('ScaleTicketDateInFrom', this.filterDateFrom);
      filterParams.addToFilter('ScaleTicketDateInTo', this.filterDateTo);
      filterParams.setFirstSort("Job.JobContact.Organization");
      filterParams.addToSorts("Job.JobDescription");
      filterParams.addToFilter('Status',1);
      filterParams.addToFilter('Status',2);
      filterParams.addToFilter('Status',4);
      filterParams.addToFilter('Status',5);
      this.generateInvoiceReport(filterParams);
      this.dateEntered = false;
      this.closeInvoiceDatePicker();
    }
  }

  generateDatePickerClicked(){
    const filterParams = new FilterParams<ScaleTicketHeader>();
    filterParams.addToFilter('ScaleTicketDateInFrom', this.filterDateFrom);
    filterParams.addToFilter('ScaleTicketDateInTo', this.filterDateTo);
    filterParams.setFirstSort("Job.JobContact.Organization");
    filterParams.addToSorts("Job.JobDescription");
    filterParams.addToFilter('Status',1);
    filterParams.addToFilter('Status',2);
    filterParams.addToFilter('Status',4);
    filterParams.addToFilter('Status',5);
    this.generateInvoiceReport(filterParams);
    this.dateEntered = false;
    this.closeInvoiceDatePicker();
  }

  handleInvoiceReportWizard(filter: FilterParams<ScaleTicketHeader>){
    if(filter) {
      this.dateEntered = true;

      if (this.invoiceDateFrom && this.incomeDateTo) {
        filter.addToFilter('ScaleTicketDateInFrom', this.filterDateFrom);
        filter.addToFilter('ScaleTicketDateInTo', this.filterDateTo);
      }

      filter.setFirstSort("Job.JobContact.Organization");
      filter.addToSorts("Job.JobDescription");
      filter.addToFilter('Status',1);
      filter.addToFilter('Status',2);
      filter.addToFilter('Status',4);
      filter.addToFilter('Status',5);
      this.generateInvoiceReport(filter);
      this.createInvoiceReportWizOpen = false;
      this.sbSvcProvider.overlaySvc.disableOverlay();
    } else {
      this.createInvoiceReportWizOpen = false;
      this.sbSvcProvider.overlaySvc.disableOverlay();
    }
  }

  generateInvoiceReport(filter){
    if (!this.isDownloading && this.dateEntered) {
      this.isDownloading = true;
      this.dateEntered = false;
      this.appGlobals.addLocationFilters(filter);
      const genTicket$ = this.invoiceSvc.generateMultipleInvoicesReportpdf(filter).pipe(share()); // customer invoice reports. all
      const notifier = new StarbaseNotificationObject(
        'Downloading...',
        null,
        StarbaseNotificationSentiment.Notice,
        null,
        genTicket$);
      genTicket$.subscribe(
        (content: any) => {
          const blob = new Blob([content], { type: 'application/pdf' });
          const downLink = document.createElement('a');
          downLink.href = window.URL.createObjectURL(blob);
          downLink.setAttribute('download', `Invoice Report ${new DatePipe('en-US').transform(new Date(), 'yyyy-MM-dd-HH-mm')}.pdf`);
          downLink.click();
          window.open(downLink.href, '_blank');
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Success');
          notifier.updateContent('Report Successfully Generated');
        },
        (e) => {
          console.error(e);
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Error');
          if(e.status == 404){
            notifier.updateContent('An error has occured.')
          }
          else{
            notifier.updateContent('Failed to Generate Report');
          }
        }
      );
      this.sbSvcProvider.notificationSvc.postNotification(notifier);
      }
  }

  launchCustomInvoiceReportBuilder() {
    this.datePickerModalForInvoiceOpen = true;
    this.forAllCustomers = true;
    this.singleCustomer = false;
    this.singleInvoice = false;
    this.isDownloading = false;
    this.sbSvcProvider.overlaySvc.enableOverlay();
  }

  launchCustomTransactionReportBuilder() {
    this.createTransactionReportWizOpen = true;
    this.forAllCustomers = true;
    this.singleCustomer = false;
    this.singleInvoice = false;
    this.isDownloading = false;
    this.sbSvcProvider.overlaySvc.enableOverlay();
  }

  launchCustomAgingDetailBuilder() {
    this.invoiceAgingDetailModalOpen = true;
    this.forAllCustomers = false;
    this.singleCustomer = true;
    this.singleInvoice = false;
    this.isDownloading = false;
    this.sbSvcProvider.overlaySvc.enableOverlay();
  }

  launchCustomerStatementReportBuilder(){
    this.customerStatementModalOpen = true;
    this.forAllCustomers = false;
    this.singleCustomer = true;
    this.singleInvoice = false;
    this.isDownloading = false;
    this.sbSvcProvider.overlaySvc.enableOverlay();
  }

  launchInvoiceReportWizard(reportType: string){
    if (reportType === "singleCustomer"){
      this.createInvoiceReportWizOpen = true;
      this.isDownloading = false;
      this.sbSvcProvider.overlaySvc.enableOverlay();
    } else if (reportType === "allCustomers"){
        this.datePickerModalForInvoiceOpen = true;
        this.isDownloading = false;
        this.sbSvcProvider.overlaySvc.enableOverlay();
    }
    else if (reportType === 'batch') { // delete later
      const filterParams = new FilterParams<Invoice>();
      filterParams.addToFilter('EODBatchUID',19);
      filterParams.setFirstSort("Job.JobContact.Organization");
      filterParams.addToSorts("Job.JobDescription");
      filterParams.addToFilter('Status',1);
      filterParams.addToFilter('Status',2);
      filterParams.addToFilter('Status',4);
      filterParams.addToFilter('Status',5);
      this.appGlobals.addLocationFilters(filterParams);

      if (!this.isDownloading) {
        this.isDownloading = true;
        const genTicket$ = this.invoiceSvc.generateMultipleInvoicesReportpdf(filterParams).pipe(share())
        const notifier = new StarbaseNotificationObject(
          'Downloading...',
          null,
          StarbaseNotificationSentiment.Notice,
          null,
          genTicket$);
        genTicket$.subscribe(
          (content: any) => {
            const blob = new Blob([content], { type: 'application/pdf' });
            const downLink = document.createElement('a');
            downLink.href = window.URL.createObjectURL(blob);
            downLink.setAttribute('download', `Invoice Report ${new DatePipe('en-US').transform(new Date(), 'yyyy-MM-dd-HH-mm')}.pdf`);
            downLink.click();
            window.open(downLink.href, '_blank');
            this.isDownloading = false;
            this.cd.detectChanges();
            notifier.updateTitle('Success');
            notifier.updateContent('Report Successfully Generated');
          },
          (e) => {
            console.error(e);
            this.isDownloading = false;
            this.cd.detectChanges();
            notifier.updateTitle('Error');
            if(e.status === 404){
              notifier.updateContent('An error has occured.')
            }
            else{
              notifier.updateContent('Failed to Generate Report');
            }
          }
        );
        this.sbSvcProvider.notificationSvc.postNotification(notifier);
        }
    }
  }

  handleTonnageReportWizard(filter: FilterParams<ScaleTicketHeader>){
    if(filter) {
      // Generate tonnage Report
      filter = this.appGlobals.addLocationFilters(filter);
      switch(this.reportStyle){
        case 'TReport':
          this.generateTonnageReport(filter);
          break;
        case 'MTReport':
          this.generateMaterialTonnageReport(filter);
          break;
        case 'STReport':
          this.generateSeasonalTonnageReport(filter);
          break;
        case 'MTSummary':
          this.generateMaterialTonnageSummary(filter);
          break;
        case 'CTReport':
          this.generateCustomerTonnageReport(filter);
          break;
        case 'EReport':
          this.generateExcelReport(filter);
          break;
        case 'TSEReport':
          this.generateTonnageSummaryExcelReport(filter);
          break;
        case 'SEReport':
          this.generateSeasonalExcelReport(filter);
          break;
        case 'QTYReport':
          this.generateQuantityReport(filter);
          break;
        case 'CMSummary':
          this.generateComprehensiveMaterialReport(filter);
          break;
      }

      this.createTonnageReportWizOpen = false;
      this.sbSvcProvider.overlaySvc.disableOverlay();
    }
    else{
      this.createTonnageReportWizOpen = false;
      this.sbSvcProvider.overlaySvc.disableOverlay();
    }
  }

  generateTonnageReport(filter: FilterParams<ScaleTicketHeader>){
    if (!this.isDownloading) {
      this.isDownloading = true;
      const genTicket$ = this.sthSvc.generateTonnagepdf(filter).pipe(share());
      const notifier = new StarbaseNotificationObject(
        'Downloading...',
        null,
        StarbaseNotificationSentiment.Notice,
        null,
        genTicket$);
      genTicket$.subscribe(
        (content: any) => {
          const blob = new Blob([content], { type: 'application/pdf' });
          const downLink = document.createElement('a');
          downLink.href = window.URL.createObjectURL(blob);
          downLink.setAttribute('download', `Tonnage Report ${new DatePipe('en-US').transform(new Date(), 'yyyy-MM-dd-HH-mm')}.pdf`);
          downLink.click();
          window.open(downLink.href, '_blank');
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Success');
          notifier.updateContent('Report Successfully Generated');
        },
        (e) => {
          console.error(e);
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Error');
          if(e.status == 404){
            notifier.updateContent('No Tickets In Date Range')
          }
          else{
            notifier.updateContent('Failed to Generate Report');
          }
        }
      );
      this.sbSvcProvider.notificationSvc.postNotification(notifier);
      }
  }

  generateQuantityReport(filter: FilterParams<ScaleTicketHeader>){
    if (!this.isDownloading) {
      this.isDownloading = true;
      const genTicket$ = this.sthSvc.generateQuantityPDF(filter).pipe(share());
      const notifier = new StarbaseNotificationObject(
        'Downloading...',
        null,
        StarbaseNotificationSentiment.Notice,
        null,
        genTicket$);
      genTicket$.subscribe(
        (content: any) => {
          const blob = new Blob([content], { type: 'application/pdf' });
          const downLink = document.createElement('a');
          downLink.href = window.URL.createObjectURL(blob);
          downLink.setAttribute('download', `Quantity Report ${new DatePipe('en-US').transform(new Date(), 'yyyy-MM-dd-HH-mm')}.pdf`);
          downLink.click();
          window.open(downLink.href, '_blank');
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Success');
          notifier.updateContent('Report Successfully Generated');
        },
        (e) => {
          console.error(e);
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Error');
          if(e.status == 404){
            notifier.updateContent('No Tickets In Date Range')
          }
          else{
            notifier.updateContent('Failed to Generate Report');
          }
        }
      );
      this.sbSvcProvider.notificationSvc.postNotification(notifier);
      }
  }

  generateQuantitySummaryReport(filter: FilterParams<ScaleTicketHeader>){
    if (!this.isDownloading) {
      this.isDownloading = true;

      const genTicket$ = this.sthSvc.generateMaterialQuantitySummaryPDF(filter).pipe(share());
      const notifier = new StarbaseNotificationObject(
        'Downloading...',
        null,
        StarbaseNotificationSentiment.Notice,
        null,
        genTicket$);
      genTicket$.subscribe(
        (content: any) => {
          const blob = new Blob([content], { type: 'application/pdf' });
          const downLink = document.createElement('a');
          downLink.href = window.URL.createObjectURL(blob);
          downLink.setAttribute('download', `Quantity Report ${new DatePipe('en-US').transform(new Date(), 'yyyy-MM-dd-HH-mm')}.pdf`);
          downLink.click();
          window.open(downLink.href, '_blank');
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Success');
          notifier.updateContent('Report Successfully Generated');
        },
        (e) => {
          console.error(e);
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Error');
          if(e.status == 404){
            notifier.updateContent('No Tickets In Date Range')
          }
          else{
            notifier.updateContent('Failed to Generate Report');
          }
        }
      );
      this.sbSvcProvider.notificationSvc.postNotification(notifier);
      }
  }

  generateMaterialTonnageReport(filter: FilterParams<ScaleTicketHeader>){
    if (!this.isDownloading) {
      this.isDownloading = true;
      const genTicket$ = this.sthSvc.generateMaterialTonnagepdf(filter).pipe(share());
      const notifier = new StarbaseNotificationObject(
        'Downloading...',
        null,
        StarbaseNotificationSentiment.Notice,
        null,
        genTicket$);
      genTicket$.subscribe(
        (content: any) => {
          const blob = new Blob([content], { type: 'application/pdf' });
          const downLink = document.createElement('a');
          downLink.href = window.URL.createObjectURL(blob);
          downLink.setAttribute('download', `Tonnage Report ${new DatePipe('en-US').transform(new Date(), 'yyyy-MM-dd-HH-mm')}.pdf`);
          downLink.click();
          window.open(downLink.href, '_blank');
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Success');
          notifier.updateContent('Report Successfully Generated');
        },
        (e) => {
          console.error(e);
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Error');
          if(e.status == 404){
            notifier.updateContent('No Tickets In Date Range')
          }
          else{
            notifier.updateContent('Failed to Generate Report');
          }
        }
      );
      this.sbSvcProvider.notificationSvc.postNotification(notifier);
      }
  }

  generateSeasonalTonnageReport(filter: FilterParams<ScaleTicketHeader>){
    if (!this.isDownloading) {
      this.isDownloading = true;
      const genTicket$ = this.sthSvc.generateSeasonalTonnagepdf(filter).pipe(share());
      const notifier = new StarbaseNotificationObject(
        'Downloading...',
        null,
        StarbaseNotificationSentiment.Notice,
        null,
        genTicket$);
      genTicket$.subscribe(
        (content: any) => {
          const blob = new Blob([content], { type: 'application/pdf' });
          const downLink = document.createElement('a');
          downLink.href = window.URL.createObjectURL(blob);
          downLink.setAttribute('download', `Seasonal Tonnage Report ${new DatePipe('en-US').transform(new Date(), 'yyyy-MM-dd-HH-mm')}.pdf`);
          downLink.click();
          window.open(downLink.href, '_blank');
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Success');
          notifier.updateContent('Report Successfully Generated');
        },
        (e) => {
          console.error(e);
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Error');
          if(e.status == 404){
            notifier.updateContent('No Tickets In Date Range')
          }
          else{
            notifier.updateContent('Failed to Generate Report');
          }
        }
      );
      this.sbSvcProvider.notificationSvc.postNotification(notifier);
      }
  }

  generateAnnualTonnageReport(filter: FilterParams<ScaleTicketHeader>){
    if (!this.isDownloading) {
      this.isDownloading = true;
      const genTicket$ = this.sthSvc.generateAnnualTonnagePDF(filter).pipe(share());
      const notifier = new StarbaseNotificationObject(
        'Downloading...',
        null,
        StarbaseNotificationSentiment.Notice,
        null,
        genTicket$);
      genTicket$.subscribe(
        (content: any) => {
          const blob = new Blob([content], { type: 'application/pdf' });
          const downLink = document.createElement('a');
          downLink.href = window.URL.createObjectURL(blob);
          downLink.setAttribute('download', `Annual Tonnage Report ${new DatePipe('en-US').transform(new Date(), 'yyyy-MM-dd-HH-mm')}.pdf`);
          downLink.click();
          window.open(downLink.href, '_blank');
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Success');
          notifier.updateContent('Report Successfully Generated');
        },
        (e) => {
          console.error(e);
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Error');
          if(e.status == 404){
            notifier.updateContent('No Tickets In Date Range')
          }
          else{
            notifier.updateContent('Failed to Generate Report');
          }
        }
      );
      this.sbSvcProvider.notificationSvc.postNotification(notifier);
      }
  }

  generateAnnualGridTonnageReport(filter: FilterParams<ScaleTicketHeader>){
    if (!this.isDownloading) {
      this.isDownloading = true;
      const genTicket$ = this.sthSvc.generateAnnualGridTonnagePDF(filter).pipe(share());
      const notifier = new StarbaseNotificationObject(
        'Downloading...',
        null,
        StarbaseNotificationSentiment.Notice,
        null,
        genTicket$);
      genTicket$.subscribe(
        (content: any) => {
          const blob = new Blob([content], { type: 'application/pdf' });
          const downLink = document.createElement('a');
          downLink.href = window.URL.createObjectURL(blob);
          downLink.setAttribute('download', `Annual Grid Tonnage Report ${new DatePipe('en-US').transform(new Date(), 'yyyy-MM-dd-HH-mm')}.pdf`);
          downLink.click();
          window.open(downLink.href, '_blank');
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Success');
          notifier.updateContent('Report Successfully Generated');
        },
        (e) => {
          console.error(e);
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Error');
          if(e.status == 404){
            notifier.updateContent('No Tickets In Date Range')
          }
          else{
            notifier.updateContent('Failed to Generate Report');
          }
        }
      );
      this.sbSvcProvider.notificationSvc.postNotification(notifier);
      }
  }

  generateAnnualComprehensiveTonnageReport(filter: FilterParams<ScaleTicketHeader>){
    if (!this.isDownloading) {
      this.isDownloading = true;
      const genTicket$ = this.sthSvc.generateAnnualComprehensiveTonnagePDF(filter).pipe(share());
      const notifier = new StarbaseNotificationObject(
        'Downloading...',
        null,
        StarbaseNotificationSentiment.Notice,
        null,
        genTicket$);
      genTicket$.subscribe(
        (content: any) => {
          const blob = new Blob([content], { type: 'application/pdf' });
          const downLink = document.createElement('a');
          downLink.href = window.URL.createObjectURL(blob);
          downLink.setAttribute('download', `Comprehensive Material Summary ${new DatePipe('en-US').transform(new Date(), 'yyyy-MM-dd-HH-mm')}.pdf`);
          downLink.click();
          window.open(downLink.href, '_blank');
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Success');
          notifier.updateContent('Report Successfully Generated');
        },
        (e) => {
          console.error(e);
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Error');
          if(e.status == 404){
            notifier.updateContent('No Tickets In Date Range')
          }
          else{
            notifier.updateContent('Failed to Generate Report');
          }
        }
      );
      this.sbSvcProvider.notificationSvc.postNotification(notifier);
      }
  }

  generateMaterialTonnageSummary(filter: FilterParams<ScaleTicketHeader>){
    if (!this.isDownloading) {
      this.isDownloading = true;
      const genTicket$ = this.sthSvc.generateMaterialTonnageSummarypdf(filter).pipe(share());
      const notifier = new StarbaseNotificationObject(
        'Downloading...',
        null,
        StarbaseNotificationSentiment.Notice,
        null,
        genTicket$);
      genTicket$.subscribe(
        (content: any) => {
          const blob = new Blob([content], { type: 'application/pdf' });
          const downLink = document.createElement('a');
          downLink.href = window.URL.createObjectURL(blob);
          downLink.setAttribute('download', `Tonnage Summary Report ${new DatePipe('en-US').transform(new Date(), 'yyyy-MM-dd-HH-mm')}.pdf`);
          downLink.click();
          window.open(downLink.href, '_blank');
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Success');
          notifier.updateContent('Report Successfully Generated');
        },
        (e) => {
          console.error(e);
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Error');
          if(e.status == 404){
            notifier.updateContent('No Tickets In Date Range')
          }
          else{
            notifier.updateContent('Failed to Generate Report');
          }
        }
      );
      this.sbSvcProvider.notificationSvc.postNotification(notifier);
      }
  }

  generateCustomerTonnageReport(filter: FilterParams<ScaleTicketHeader>){
    if (!this.isDownloading) {
      this.isDownloading = true;
      const genTicket$ = this.sthSvc.generateCustomerTonnagepdf(filter).pipe(share());
      const notifier = new StarbaseNotificationObject(
        'Downloading...',
        null,
        StarbaseNotificationSentiment.Notice,
        null,
        genTicket$);
      genTicket$.subscribe(
        (content: any) => {
          const blob = new Blob([content], { type: 'application/pdf' });
          const downLink = document.createElement('a');
          downLink.href = window.URL.createObjectURL(blob);
          downLink.setAttribute('download', `Tonnage Report By Customer & Job ${new DatePipe('en-US').transform(new Date(), 'yyyy-MM-dd-HH-mm')}.pdf`);
          downLink.click();
          window.open(downLink.href, '_blank');
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Success');
          notifier.updateContent('Report Successfully Generated');
        },
        (e) => {
          console.error(e);
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Error');
          if(e.status == 404){
            notifier.updateContent('No Tickets In Date Range')
          }
          else{
            notifier.updateContent('Failed to Generate Report');
          }
        }
      );
      this.sbSvcProvider.notificationSvc.postNotification(notifier);
      }
  }

  generateExcelReport(filter: FilterParams<ScaleTicketHeader>){
    if (!this.isDownloading) {
      this.isDownloading = true;
      const genExcel$ = this.sthSvc.getTonnageExcel(filter).pipe(share());
      const notifier = new StarbaseNotificationObject(
        'Downloading...',
        null,
        StarbaseNotificationSentiment.Notice,
        null,
        genExcel$);
      genExcel$.subscribe(
        (content: any) => {
          const blob = new Blob([content], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const downLink = document.createElement('a');
          downLink.href = window.URL.createObjectURL(blob);
          downLink.setAttribute('download', `Tonnage Report ${new DatePipe('en-US').transform(new Date(), 'yyyy-MM-dd-HH-mm')}.xlsx`);
          downLink.click();
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Success');
          notifier.updateContent('Excel Report Successfully Generated');
        },
        (e) => {
          console.error(e);
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Error');
          if(e.status == 404){
            notifier.updateContent('No Tickets In Date Range')
          }
          else{
            notifier.updateContent('Failed to Generate Report');
          }
        }
      );
      this.sbSvcProvider.notificationSvc.postNotification(notifier);
    }
  }

  generateSeasonalExcelReport(filter: FilterParams<ScaleTicketHeader>){
    if (!this.isDownloading) {
      this.isDownloading = true;
      const genExcel$ = this.sthSvc.getSeasonalTonnageExcel(filter).pipe(share());
      const notifier = new StarbaseNotificationObject(
        'Downloading...',
        null,
        StarbaseNotificationSentiment.Notice,
        null,
        genExcel$);
      genExcel$.subscribe(
        (content: any) => {
          const blob = new Blob([content], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const downLink = document.createElement('a');
          downLink.href = window.URL.createObjectURL(blob);
          downLink.setAttribute('download', `Seasonal Tonnage Report ${new DatePipe('en-US').transform(new Date(), 'yyyy-MM-dd-HH-mm')}.xlsx`);
          downLink.click();
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Success');
          notifier.updateContent('Excel Report Successfully Generated');
        },
        (e) => {
          console.error(e);
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Error');
          if(e.status == 404){
            notifier.updateContent('No Tickets In Date Range')
          }
          else{
            notifier.updateContent('Failed to Generate Report');
          }
        }
      );
      this.sbSvcProvider.notificationSvc.postNotification(notifier);
    }
  }


  generateTonnageSummaryExcelReport(filter: FilterParams<ScaleTicketHeader>){
    if (!this.isDownloading) {
      this.isDownloading = true;
      const genExcel$ = this.sthSvc.getTonnageSummaryExcel(filter).pipe(share());
      const notifier = new StarbaseNotificationObject(
        'Downloading...',
        null,
        StarbaseNotificationSentiment.Notice,
        null,
        genExcel$);
      genExcel$.subscribe(
        (content: any) => {
          const blob = new Blob([content], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const downLink = document.createElement('a');
          downLink.href = window.URL.createObjectURL(blob);
          downLink.setAttribute('download', `Tonnage Summary Report ${new DatePipe('en-US').transform(new Date(), 'yyyy-MM-dd-HH-mm')}.xlsx`);
          downLink.click();
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Success');
          notifier.updateContent('Excel Report Successfully Generated');
        },
        (e) => {
          console.error(e);
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Error');
          if(e.status == 404){
            notifier.updateContent('No Tickets In Date Range')
          }
          else{
            notifier.updateContent('Failed to Generate Report');
          }
        }
      );
      this.sbSvcProvider.notificationSvc.postNotification(notifier);
    }
  }

  public generateAccountCreditReport() {
    if (!this.isDownloading) {
      this.isDownloading = true;
      const filters = new FilterParams<STContact>();
      filters.addToFilter('active', true);
      const jobExcel$ = this.contactDashSvc.getAccountCreditPDF(filters).pipe(share());
      const notifier = new StarbaseNotificationObject(
        'Downloading...',
        null,
        StarbaseNotificationSentiment.Notice,
        null,
        jobExcel$);
      jobExcel$.subscribe(
        (content: any) => {
          const blob = new Blob([content], { type: 'application/pdf' });
          const downLink = document.createElement('a');
          downLink.href = window.URL.createObjectURL(blob);
          // eslint-disable-next-line max-len
          downLink.setAttribute('download', `Account Credit Report ${new DatePipe('en-US').transform(new Date(), 'yyyy-MM-dd-HH-mm')}.pdf`);
          downLink.click();
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Success');
          notifier.updateContent('Account Credit report successfully generated');
        },
        (e) => {
          console.error(e);
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Error');
          notifier.updateContent('Failed to download Account Credit report.');
        }
      );
      this.sbSvcProvider.notificationSvc.postNotification(notifier);
    }
  }

  generateCustomerAgingReport() {
    if (!this.isDownloading) {
      this.isDownloading = true;
      const genTicket$ = this.invoiceSvc.generateCustomerAgingReportPDF(this.asOf != null ? new Date(this.asOf) : null).pipe(share());
      const notifier = new StarbaseNotificationObject(
        'Downloading...',
        null,
        StarbaseNotificationSentiment.Notice,
        null,
        genTicket$);
      genTicket$.subscribe(
        (content: any) => {
          const blob = new Blob([content], { type: 'application/pdf' });
          const downLink = document.createElement('a');
          downLink.href = window.URL.createObjectURL(blob);
          downLink.setAttribute('download', `Customer Aging Report ${new DatePipe('en-US').transform(new Date(), 'yyyy-MM-dd-HH-mm')}.pdf`);
          downLink.click();
          window.open(downLink.href, '_blank');
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Success');
          notifier.updateContent('Report Successfully Generated');
        },
        (e) => {
          console.error(e);
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Error');
          if (e.status === 404) {
            notifier.updateContent('No Data to Report')
          }
          else {
            notifier.updateContent('Failed to Generate Report');
          }
        }
      );
      this.sbSvcProvider.notificationSvc.postNotification(notifier);
    }
  }

  generateComprehensiveMaterialReport(filter: FilterParams<ScaleTicketHeader>){
    if (!this.isDownloading) {
      this.isDownloading = true;
      const genTicket$ = this.sthSvc.generateComprehensiveTonnagePDF(filter).pipe(share());
      const notifier = new StarbaseNotificationObject(
        'Downloading...',
        null,
        StarbaseNotificationSentiment.Notice,
        null,
        genTicket$);
      genTicket$.subscribe(
        (content: any) => {
          const blob = new Blob([content], { type: 'application/pdf' });
          const downLink = document.createElement('a');
          downLink.href = window.URL.createObjectURL(blob);
          downLink.setAttribute('download', `Comprehensive Material Report ${new DatePipe('en-US').transform(new Date(), 'yyyy-MM-dd-HH-mm')}.pdf`);
          downLink.click();
          window.open(downLink.href, '_blank');
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Success');
          notifier.updateContent('Report Successfully Generated');
        },
        (e) => {
          console.error(e);
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Error');
          if(e.status == 404){
            notifier.updateContent('No Tickets In Date Range')
          }
          else{
            notifier.updateContent('Failed to Generate Report');
          }
        }
      );
      this.sbSvcProvider.notificationSvc.postNotification(notifier);
      }
  }

  generateInvoiceAgingReport() {
    if (!this.isDownloading) {
      this.isDownloading = true;
      const genTicket$ = this.invoiceSvc.generateInvoiceAgingReportPDF(this.asOf != null ? new Date(this.asOf) : null, this.appGlobals.getSelectedLocationUIDFilter()).pipe(share());
      const notifier = new StarbaseNotificationObject(
        'Downloading...',
        null,
        StarbaseNotificationSentiment.Notice,
        null,
        genTicket$);
      genTicket$.subscribe(
        (content: any) => {
          const blob = new Blob([content], { type: 'application/pdf' });
          const downLink = document.createElement('a');
          downLink.href = window.URL.createObjectURL(blob);
          downLink.setAttribute('download', `Invoice Aging Report ${new DatePipe('en-US').transform(new Date(), 'yyyy-MM-dd-HH-mm')}.pdf`);
          downLink.click();
          window.open(downLink.href, '_blank');
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Success');
          notifier.updateContent('Report Successfully Generated');
        },
        (e) => {
          console.error(e);
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Error');
          if (e.status === 404) {
            notifier.updateContent('No Data to Report')
          }
          else {
            notifier.updateContent('Failed to Generate Report');
          }
        }
      );
      this.sbSvcProvider.notificationSvc.postNotification(notifier);
    }
  }

  generateInvoiceAgingDetailReport(){
    if (!this.isDownloading) {
      if (this.singleCustomer) {
        this.isDownloading = true;
        const genTicket$ = this.invoiceSvc.generateAgingDetailReportPDF(this.customer.uid, this.appGlobals.getSelectedLocationUIDFilter()).pipe(share());
        this.closeInvoiceAgingDetailDatePicker();
        const notifier = new StarbaseNotificationObject(
          'Downloading...',
          null,
          StarbaseNotificationSentiment.Notice,
          null,
          genTicket$);
        genTicket$.subscribe(
          (content: any) => {
            const blob = new Blob([content], { type: 'application/pdf' });
            const downLink = document.createElement('a');
            downLink.href = window.URL.createObjectURL(blob);
            downLink.setAttribute('download', `Invoice Aging Detail Report ${new DatePipe('en-US').transform(new Date(), 'yyyy-MM-dd-HH-mm')}.pdf`);
            downLink.click();
            window.open(downLink.href, '_blank');
            this.isDownloading = false;
            this.cd.detectChanges();
            notifier.updateTitle('Success');
            notifier.updateContent('Report Successfully Generated');
          },
          (e) => {
            console.error(e);
            this.isDownloading = false;
            this.cd.detectChanges();
            notifier.updateTitle('Error');
            if (e.status === 404) {
              notifier.updateContent('No Data to Report')
            }
            else {
              notifier.updateContent('Failed to Generate Report');
            }
          }
        );
        this.sbSvcProvider.notificationSvc.postNotification(notifier);
      } else {
        this.isDownloading = true;
        const genTicket$ = this.invoiceSvc.generateAgingDetailReportPDF(null, this.appGlobals.getSelectedLocationUIDFilter()).pipe(share());
        this.closeInvoiceAgingDetailDatePicker();
        const notifier = new StarbaseNotificationObject(
          'Downloading...',
          null,
          StarbaseNotificationSentiment.Notice,
          null,
          genTicket$);
        genTicket$.subscribe(
          (content: any) => {
            const blob = new Blob([content], { type: 'application/pdf' });
            const downLink = document.createElement('a');
            downLink.href = window.URL.createObjectURL(blob);
            downLink.setAttribute('download', `Invoice Aging Detail Report ${new DatePipe('en-US').transform(new Date(), 'yyyy-MM-dd-HH-mm')}.pdf`);
            downLink.click();
            window.open(downLink.href, '_blank');
            this.isDownloading = false;
            this.cd.detectChanges();
            notifier.updateTitle('Success');
            notifier.updateContent('Report Successfully Generated');
          },
          (e) => {
            console.error(e);
            this.isDownloading = false;
            this.cd.detectChanges();
            notifier.updateTitle('Error');
            if (e.status === 404) {
              notifier.updateContent('No Data to Report')
            }
            else {
              notifier.updateContent('Failed to Generate Report');
            }
          }
        );
        this.sbSvcProvider.notificationSvc.postNotification(notifier);
      }
    }
  }

  generateCustomerStatementReport(){
    this.isDownloading = true;
    const filter = new FilterParams<Invoice>();
    this.appGlobals.addLocationFilters(filter);
    this.filterDateFrom ? filter.addToFilter('InvoiceDateFrom', this.invoiceDateFrom) : ''
    this.filterDateTo ? filter.addToFilter('InvoiceDateTo', this.filterDateTo) : ''
    this.asOf ? filter.addToFilter('AsOf', this.asOf) : ''
        const genTicket$ = this.invoiceSvc.generateCustomerStatementPDF(this.customer.uid, true, filter).pipe(share());
        this.closeCustomerStatement();
        const notifier = new StarbaseNotificationObject(
          'Downloading...',
          null,
          StarbaseNotificationSentiment.Notice,
          null,
          genTicket$);
        genTicket$.subscribe(
          (content: any) => {
            const blob = new Blob([content], { type: 'application/pdf' });
            const downLink = document.createElement('a');
            downLink.href = window.URL.createObjectURL(blob);
            downLink.setAttribute('download', `Customer Statement ${new DatePipe('en-US').transform(new Date(), 'yyyy-MM-dd-HH-mm')}.pdf`);
            downLink.click();
            window.open(downLink.href, '_blank');
            this.isDownloading = false;
            this.cd.detectChanges();
            notifier.updateTitle('Success');
            notifier.updateContent('Report Successfully Generated');
          },
          (e) => {
            console.error(e);
            this.isDownloading = false;
            this.cd.detectChanges();
            notifier.updateTitle('Error');
            if (e.status === 404) {
              notifier.updateContent('No Data to Report')
            }
            else {
              notifier.updateContent('Failed to Generate Report');
            }
          }
        );
        this.filterDateFrom = null;
        this.filterDateTo = null;
        this.sbSvcProvider.notificationSvc.postNotification(notifier);
  }

  toggleFavorite(reportId: string, reportName: string): void {
    if (this.isFavorite(reportId)) {
      this.appGlobals.removeFavoriteReport(reportId);
      this.favoriteReports = this.appGlobals.getFavoriteReports();
      const notifier = new StarbaseNotificationObject(
        'Favorites Updated',
        `${reportName} removed from favorites`,
        StarbaseNotificationSentiment.Info,
        null,
        null
      );
      this.sbSvcProvider.notificationSvc.postNotification(notifier);

    } else {
      this.appGlobals.addFavoriteReport(reportId);
      this.favoriteReports = this.appGlobals.getFavoriteReports();
      const notifier = new StarbaseNotificationObject(
        'Favorites Updated',
        `${reportName} added to favorites`,
        StarbaseNotificationSentiment.Notice,
        null,
        null
      );
      this.sbSvcProvider.notificationSvc.postNotification(notifier);
    }
    this.hasFavorites = this.favoriteReports.length > 0;
  }

  isFavorite(reportId: string): boolean {
    return this.appGlobals.isFavoriteReport(reportId);
  }

  toggleTonnageCollapse(): void {
    this.collapseTonnage = !this.collapseTonnage;
    this.appGlobals.setReportSectionCollapseState('tonnage', this.collapseTonnage);
  }

  toggleTonFinanceCollapse(): void {
    this.collapseTonFinance = !this.collapseTonFinance;
    this.appGlobals.setReportSectionCollapseState('tonFinance', this.collapseTonFinance);
  }

  toggleInvoiceCollapse(): void {
    this.collapseInvoice = !this.collapseInvoice;
    this.appGlobals.setReportSectionCollapseState('invoice', this.collapseInvoice);
  }

  toggleFavoritesCollapse(): void {
    this.collapseFavorites = !this.collapseFavorites;
    this.appGlobals.setReportSectionCollapseState('favorites', this.collapseFavorites);
  }

  asOfChange(): void {
    if (this.asOf) {
      this.asOf = new Date(this.asOf.setHours(23, 59, 59, 999));
    }
  }

}

// create new report 2 wizard for invoice selection - filtering by a date range and specific customer.
